import React, { Component } from 'react';
import { ApolloProvider, Query } from "react-apollo";
import { mutationCreateTenant, mutationUpdateTenant, mutationUpdateAudioStorage, mutationBulkImport, reprocessAnalytics, queryGetTenantList, deleteTenant, insertMessage, userGroupSync, changeEncryptionKey, checkCustomKeyVault, checkMaxRetentionTimeSettings, createCustomKeySecret, deleteTenantMetadataQuery, queryGetAWSRegions, createAsymmetricKey, getStorageData, checkS3StorageConnection, checkEventHubUrlValidity, checkKafkaUrlValidity, checkTenantForDeletion, getTenantRegions } from "../../../queries/querySettings";
import { Dropdown, DropdownMenuItemType, IDropdownStyles, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { queryGetRuleData } from "../../../queries/querySettings";
import { DatePicker } from 'office-ui-fabric-react/lib/DatePicker';
import UserPicker from '../../ReportView/ReportConfiguration/UserPicker';
import DateTimePicker from 'react-datetime-picker';

import Utils from "./../../common/Utils";

import {
    DefaultButton,
    PrimaryButton,
    Stack,
    TextField,
    ComboBox,
    Checkbox,
    Spinner,
    Panel,
    PanelType,
    Label,
    Text,
    SpinButton,
    ChoiceGroup,
    Modal,
    IconButton,
    TeachingBubble,
    hasHorizontalOverflow
} from "office-ui-fabric-react";
import { toast } from "react-toastify";
import { MyContext } from '../../../context';
import ExportConfig from './ExportConfig';
import ImportConfig from './ImportConfig';
import AudioStorageConfig from './AudioStorageConfig';
import BotOnboardingConfig from './BotOnboardingConfig';
import "../fabric-icons-inline.css";
import { Button } from '@fluentui/react';
import { text } from 'react-dom-factories';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { isString, isUndefined } from 'lodash';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react';

const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 250 }
};
const contentStyles = mergeStyleSets({
    container: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'stretch',
    },
    header: [
        {
            flex: '1 1 auto',
            borderTop: '4px solid blue',
            // color: theme.palette.neutralPrimary,
            display: 'flex',
            // fontSize: FontSizes.xLarge,
            alignItems: 'center',
            // fontWeight: FontWeights.semibold,
            padding: '12px 12px 14px 24px',
        },
    ],
    body: {
        flex: '4 4 auto',
        padding: '0 24px 24px 24px',
        overflowY: 'hidden',
        selectors: {
            p: {
                margin: '14px 0',
            },
            'p:first-child': {
                marginTop: 0,
            },
            'p:last-child': {
                marginBottom: 0,
            },
        },
    },
});

const iconButtonStyles = mergeStyleSets({
    root: {
        marginLeft: 'auto',
        marginTop: '4px',
        marginRight: '2px',
    }
});

export default class AddTenant extends React.Component {
    static contextType = MyContext

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.openExportSettings = this.openExportSettings.bind(this);
        this._onDismissExportPanel = this._onDismissExportPanel.bind(this);
        this._onOpenExportPanel = this._onOpenExportPanel.bind(this);

        this.openImportSettings = this.openImportSettings.bind(this);
        this._onDismissImportPanel = this._onDismissImportPanel.bind(this);
        this._onOpenImportPanel = this._onOpenImportPanel.bind(this);

        this.openAudioStorageSettings = this.openAudioStorageSettings.bind(this);
        this._onDismissAudioStoragePanel = this._onDismissAudioStoragePanel.bind(this);
        this._onOpenAudioStoragePanel = this._onOpenAudioStoragePanel.bind(this);
        this.openBotOnboardingSettings = this.openBotOnboardingSettings.bind(this);
        this._onDismissBotOnboardingPanel = this._onDismissBotOnboardingPanel.bind(this);
        this._onOpenBotOnboardingPanel = this._onOpenBotOnboardingPanel.bind(this);




        const text = <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyManagement")}</>)}</MyContext.Consumer>;
        if (this.props.data != null && this.props.data !== undefined) {
            this.state = {
                name: this.props.data.name,
                adminId: this.props.data.adminId,
                tenantId: this.props.data.tenantId,
                cloudTenantId: this.props.data.cloudTenantId,
                id: this.props.data.id,
                license1: this.props.data.licenseComp != null ? this.props.data.licenseComp.bought : 0,
                license1used: this.props.data.licenseComp != null ? this.props.data.licenseComp.used : 0,
                license1id: this.props.data.licenseComp != null ? this.props.data.licenseComp.id : Utils.guidGenerator(),
                license2: this.props.data.licenseCompAna != null ? this.props.data.licenseCompAna.bought : 0,
                license2used: this.props.data.licenseCompAna != null ? this.props.data.licenseCompAna.used : 0,
                license2id: this.props.data.licenseCompAna != null ? this.props.data.licenseCompAna.id : Utils.guidGenerator(),
                license3: this.props.data.licenseSmart != null ? this.props.data.licenseSmart.bought : 0,
                license3used: this.props.data.licenseSmart != null ? this.props.data.licenseSmart.used : 0,
                license3id: this.props.data.licenseSmart != null ? this.props.data.licenseSmart.id : Utils.guidGenerator(),
                license4: this.props.data.licenseSmartAna != null ? this.props.data.licenseSmartAna.bought : 0,
                license4used: this.props.data.licenseSmartAna != null ? this.props.data.licenseSmartAna.used : 0,
                license4id: this.props.data.licenseSmartAna != null ? this.props.data.licenseSmartAna.id : Utils.guidGenerator(),
                license5: this.props.data.licenseAna != null ? this.props.data.licenseAna.bought : 0,
                license5used: this.props.data.licenseAna != null ? this.props.data.licenseAna.used : 0,
                license5id: this.props.data.licenseAna != null ? this.props.data.licenseAna.id : Utils.guidGenerator(),
                license6: this.props.data.licenseCompVoice != null ? this.props.data.licenseCompVoice.bought : 0,
                license6used: this.props.data.licenseCompVoice != null ? this.props.data.licenseCompVoice.used : 0,
                license6id: this.props.data.licenseCompVoice != null ? this.props.data.licenseCompVoice.id : Utils.guidGenerator(),
                license7: this.props.data.licenseCompVoiceAna != null ? this.props.data.licenseCompVoiceAna.bought : 0,
                license7used: this.props.data.licenseCompVoiceAna != null ? this.props.data.licenseCompVoiceAna.used : 0,
                license7id: this.props.data.licenseCompVoiceAna != null ? this.props.data.licenseCompVoiceAna.id : Utils.guidGenerator(),
                license8: this.props.data.licenseSmartVoice != null ? this.props.data.licenseSmartVoice.bought : 0,
                license8used: this.props.data.licenseSmartVoice != null ? this.props.data.licenseSmartVoice.used : 0,
                license8id: this.props.data.licenseSmartVoice != null ? this.props.data.licenseSmartVoice.id : Utils.guidGenerator(),
                license9: this.props.data.licenseSmartVoiceAna != null ? this.props.data.licenseSmartVoiceAna.bought : 0,
                license9used: this.props.data.licenseSmartVoiceAna != null ? this.props.data.licenseSmartVoiceAna.used : 0,
                license9id: this.props.data.licenseSmartVoiceAna != null ? this.props.data.licenseSmartVoiceAna.id : Utils.guidGenerator(),
                license10: this.props.data.licenseRecordingInsinghtsAI != null ? this.props.data.licenseRecordingInsinghtsAI.bought : 0,
                license10used: this.props.data.licenseRecordingInsinghtsAI != null ? this.props.data.licenseRecordingInsinghtsAI.used : 0,
                license10id: this.props.data.licenseRecordingInsinghtsAI != null ? this.props.data.licenseRecordingInsinghtsAI.id : Utils.guidGenerator(),
                license11: this.props.data.licenseSmartBase != null ? this.props.data.licenseSmartBase.bought : 0,
                license11used: this.props.data.licenseSmartBase != null ? this.props.data.licenseSmartBase.used : 0,
                license11id: this.props.data.licenseSmartBase != null ? this.props.data.licenseSmartBase.id : Utils.guidGenerator(),
                license12: this.props.data.licenseComplianceBase != null ? this.props.data.licenseComplianceBase.bought : 0,
                license12used: this.props.data.licenseComplianceBase != null ? this.props.data.licenseComplianceBase.used : 0,
                license12id: this.props.data.licenseComplianceBase != null ? this.props.data.licenseComplianceBase.id : Utils.guidGenerator(),
                license13: this.props.data.licenseEntryVoiceRecording != null ? this.props.data.licenseEntryVoiceRecording.bought : 0,
                license13used: this.props.data.licenseEntryVoiceRecording != null ? this.props.data.licenseEntryVoiceRecording.used : 0,
                license13id: this.props.data.licenseEntryVoiceRecording?.id ?? Utils.guidGenerator(),
                storage: this.props.data.storageId,
                customStorage: this.props.data.customStorage,
                packageStorage: this.props.data.packageStorage != null ? this.props.data.packageStorage : 0,
                packageAnalyticsSpeech: this.props.data.packageAnalyticsSpeech != null ? this.props.data.packageAnalyticsSpeech : 0,
                packageAnalyticsTranscript: this.props.data.packageAnalyticsTranscript != null ? this.props.data.packageAnalyticsTranscript : 0,
                packageAnalyticsBatchTranscript: this.props.data.packageAnalyticsBatchTranscript != null ? this.props.data.packageAnalyticsBatchTranscript : 0,
                packageAnalyticsVideo: this.props.data.packageAnalyticsVideo != null ? this.props.data.packageAnalyticsVideo : 0,
                packageAnalyticsTranslate: this.props.data.packageAnalyticsTranslate != null ? this.props.data.packageAnalyticsTranslate : 0,
                packageAnalyticsAI: this.props.data.packageAnalyticsAI != null ? this.props.data.packageAnalyticsAI : 0,
                analyticsSpeechCapacity: this.props.data.analyticsSpeechCapacity != null ? this.props.data.analyticsSpeechCapacity : "30",
                analyticsTranscriptCapacity: this.props.data.analyticsTranscriptCapacity != null ? this.props.data.analyticsTranscriptCapacity : "30",
                analyticsBatchTranscriptCapacity: this.props.data.analyticsBatchTranscriptCapacity != null ? this.props.data.analyticsBatchTranscriptCapacity : "30",
                analyticsVideoCapacity: this.props.data.analyticsVideoCapacity != null ? this.props.data.analyticsVideoCapacity : "30",
                analyticsTranslateCapacity: this.props.data.analyticsTranslateCapacity != null ? this.props.data.analyticsTranslateCapacity : "30",
                analyticsAICapacity: this.props.data.analyticsAICapacity != null ? this.props.data.analyticsAICapacity : "20000000",
                packageExport: this.props.data.packageExport != null ? this.props.data.packageExport : 0,
                addOnAnalytics: this.props.data.addOnAnalytics != null ? this.props.data.addOnAnalytics : 0,
                addOnAIEntry: this.props.data.addOnAIEntry != null ? this.props.data.addOnAIEntry : 0,
                addOnFullChat: this.props.data.addOnFullChat != null ? this.props.data.addOnFullChat : 0,
                addOnZoom: this.props.data.addOnZoom != null ? this.props.data.addOnZoom : 0,
                addOnGenesys: this.props.data.addOnGenesys != null ? this.props.data.addOnGenesys : 0,
                addOnRingcentral: this.props.data.addOnRingcentral != null ? this.props.data.addOnRingcentral : 0,
                addOnCloud9: this.props.data.addOnCloud9 != null ? this.props.data.addOnCloud9 : 0,
                addOnDynamics: this.props.data.addOnDynamics != null ? this.props.data.addOnDynamics : 0,
                addOnWebex: this.props.data.addOnWebex != null ? this.props.data.addOnWebex : 0,
                addOnCompliance: this.props.data.addOnCompliance != null ? this.props.data.addOnCompliance : 0,
                addOnQualityManagement: this.props.data.addOnQualityManagement != null ? this.props.data.addOnQualityManagement : 0,
                addOnRealTimeTranscript: this.props.data.addOnRealTimeTranscript != null ? this.props.data.addOnRealTimeTranscript : 0,
                addOnLeapXpert: this.props.data.addOnLeapXpert != null ? this.props.data.addOnLeapXpert : 0,
                addOnMsftTeamsVoice: this.props.data?.addOnMsftTeamsVoice ?? 0,
                addOnMsftTeamsUC: this.props.data?.addOnMsftTeamsUC ?? 0,
                addOnEmail: this.props.data.addOnEmail != null ? this.props.data.addOnEmail : 0,
                addOnN1Mapping: this.props.data?.addOnN1Mapping ?? 0,
                mailAlarming: this.props.data.mailAlarming != null ? this.props.data.mailAlarming : "",
                commercialContactMail: this.props.data.commercialContactMail != null ? this.props.data.commercialContactMail : "",
                contractNumber: this.props.data.contractNumber != null ? this.props.data.contractNumber : "",
                exportType: this.props.data.exportType,
                exportStorage: this.props.data.exportStorage,
                type: this.props.data.type,
                keyManagementType: this.props.data?.keyManagementType ?? "No",
                keySecurity: this.props.data?.keyManagement?.keySecurity ?? "Aes128",
                rotationType: this.props.data?.keyManagement?.rotationType ?? "Interval",
                intervalDays: this.props.data?.keyManagement?.intervalDays ?? 365,
                activationDelay: this.props.data?.keyManagement?.activationDelay ?? 0,
                willExpire: (this.props.data?.keyManagement?.willExpire === "Yes") ?? false,
                expireDays: this.props.data?.keyManagement?.expireDays ?? 0,
                customEncryptionKeyVaultUrl: this.props.data?.keyManagement?.customEncryptionKeyVaultUrl ?? "",
                customEncryptionKeySecretName: this.props.data?.keyManagement?.customEncryptionKeySecretName ?? "",
                manualCreationCustom: false,
                manualCreationKeyRotation: false,
                isChanged: false,
                bulkImport: false,
                bulkLicense: "0",
                bulkRuleRecording: "",
                bulkRuleReplay: "",
                bulkRuleAccess: "",
                bulkRuleAnalytics: "",
                bulkUserList: "",
                bulkImportText: "",
                deleteTenantText: "",
                deleteTenant: "",
                deleteTenantMetadataText: "",
                deleteTenantMetadata: "",
                deleteTenantMetadataDate: new Date('2019-01-01'),
                deleteTenantMetadataStatus: undefined,
                deletePassword: "",
                insertMessage: "",
                insertMessageContent: "",
                insertMessageText: "",
                country: this.props.data.country != null ? this.props.data.country : "",

                partner: this.props.data.partner != null ? this.props.data.partner : "",
                onboardingDate: (this.props.data.onboardingDate !== '' && this.props.data.onboardingDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.onboardingDate) : '',
                billingDate: (this.props.data.billingDate !== '' && this.props.data.billingDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.billingDate) : '',
                trainingDate: (this.props.data.trainingDate !== '' && this.props.data.trainingDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.trainingDate) : '',
                supportNotes: this.props.data.supportNotes != null ? this.props.data.supportNotes : "",
                systemId: this.props.data.systemId != null ? this.props.data.systemId : "",
                bots: this.props.data.bots != null ? this.props.data.bots : [],
                support: this.props.data.support != null ? this.props.data.support : "",
                partnerContract: this.props.data.partnerContract != null ? this.props.data.partnerContract : "",
                botVisible: false,
                showExportPanel: false,
                showImportPanel: false,
                showAudioStoragePanel: false,
                audioStorageOverride: null,
                showBotOnboardingPanel: false,
                isSaving: false,
                keyManagementEnabled: this.props.data?.keyManagementEnabled ?? false,
                chatModelA: this.props.data.chatModelA != null ? this.props.data.chatModelA : false,
                showTicketPage: this.props.data.showTicketPage != null ? this.props.data.showTicketPage : false,
                validateKeyVault: "",
                domainRestrictionsList: this.props.data.domainRestrictionsList,
                isChecked: false,
                showModal: false,
                packageImport: this.props.data.packageImport != null ? this.props.data.packageImport : 0,
                packageArchive: this.props.data.packageArchive != null ? this.props.data.packageArchive : 0,
                tenantSuspensionConvDelProcess: this.props.data.tenantSuspensionConvDelProcess !== null ? this.props.data.tenantSuspensionConvDelProcess : false,
                deletionNotifyMessage: false,
                keyExpirationMessage: false,
                keyExpirationButtonMessage: false,
                maxTtlFound: "0",
                keyExpirationConfirmed: true,
                awsAccessKeyId: this.props.data !== null ? this.props.data.awsAccessKeyId : "",
                awsSecretAccess: this.props.data !== null ? this.props.data.awsSecretAccess : "",
                awsBucketName: this.props.data !== null ? this.props.data.awsBucketName : "",
                awsRegion: this.props.data !== null ? this.props.data.awsRegion : "",
                awsType: this.props.data !== null ? this.props.data.awsType : "",
                awsServiceUrl: this.props.data !== null ? this.props.data.awsServiceUrl : "",
                asymmetricKeyEnabled: this.props.data?.keyManagement?.asymmetricKeyEnabled ?? false,
                hsm: this.props.data?.keyManagement?.hsm ?? false,
                keyType: this.props.data?.keyManagement?.asymmetricKeySettings?.keyType ?? "RSA",
                keySetting: this.props.data?.keyManagement?.asymmetricKeySettings?.keySetting ?? "",
                asymmetricKeyFileName: this.props.data?.keyManagement?.asymmetricKeySettings?.asymmetricKeyFileName ?? "",
                uploadedContent: "",
                selectedFile: !!this.props.data?.keyManagement?.asymmetricKeySettings,
                asymmetricKeyButtonText: "createAsymmetricKey",
                interactionLogging: this.props.data.interactionLogging,
                loggingStartDate: (this.props.data.loggingStartDate != null && this.props.data.loggingStartDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.loggingStartDate) : null,
                loggingStopDate: (this.props.data.loggingStopDate != null && this.props.data.loggingStopDate !== '0001-01-01T00:00:00.0000000') ? new Date(this.props.data.loggingStopDate) : null,
                allowedUsers: this.props.data.allowedUsers !== null ? this.props.data.allowedUsers.map(u => u.userId) : [],
                checkboxAILogging: this.props.data.interactionLogging === true ? true : false,
                interactionTeachingBubble: false,
                processingRegion: this.props.data.processingRegion != null ? this.props.data.processingRegion : "North Europe",
                eventHubVisible: !this.props.data.eventHubNamespace || !this.props.data.eventHubName ? false : true,
                eventHubNamespace: this.props.data.eventHubNamespace || "",
                eventHubName: this.props.data.eventHubName || "",
                validateEventHubUrl: "false",
                kafkaVisible: !this.props.data.kafkaBootstrapServers || !this.props.data.kafkaTopic ? false : true,
                kafkaBootstrapServers: this.props.data.kafkaBootstrapServers || "",
                kafkaTopic: this.props.data.kafkaTopic || "",
                kafkaSecurityProtocol: this.props.data.kafkaSecurityProtocol || "",
                kafkaSslCaLocation: this.props.data.kafkaSslCaLocation || "",
                kafkaSslCertificateLocation: this.props.data.kafkaSslCertificateLocation || "",
                kafkaSslKeyLocation: this.props.data.kafkaSslKeyLocation || "",
                kafkaSslKeyPassword: this.props.data.kafkaSslKeyPassword || "",
                kafkaSaslMechanism: this.props.data.kafkaSaslMechanism || "",
                kafkaSaslUsername: this.props.data.kafkaSaslUsername || "",
                kafkaSaslPassword: this.props.data.kafkaSaslPassword || "",
                validateKafkaUrl: "false",
                checkTenantForDelete: undefined,
                checkTenantForDeleteError: "",
                error: {},
                createSubUnit: false
            }
        }
        else {
            this.state = {
                name: "",
                adminId: "",
                tenantId: "",
                cloudTenantId: "",
                id: null,
                license1: 0,
                license1used: 0,
                license1id: Utils.guidGenerator(),
                license2: 0,
                license2used: 0,
                license2id: Utils.guidGenerator(),
                license3used: 0,
                license3: 0,
                license3id: Utils.guidGenerator(),
                license4: 0,
                license4used: 0,
                license4id: Utils.guidGenerator(),
                license5: 0,
                license5used: 0,
                license5id: Utils.guidGenerator(),
                license6: 0,
                license6used: 0,
                license6id: Utils.guidGenerator(),
                license7: 0,
                license7used: 0,
                license7id: Utils.guidGenerator(),
                license8: 0,
                license8used: 0,
                license8id: Utils.guidGenerator(),
                license9: 0,
                license9used: 0,
                license9id: Utils.guidGenerator(),
                license10: 0,
                license10used: 0,
                license10id: Utils.guidGenerator(),
                license11: 0,
                license11used: 0,
                license11id: Utils.guidGenerator(),
                license12: 0,
                license12used: 0,
                license12id: Utils.guidGenerator(),
                license13: 0,
                license13used: 0,
                license13id: Utils.guidGenerator(),
                storage: "",
                customStorage: "",
                packageStorage: 0,
                packageAnalyticsSpeech: 0,
                packageAnalyticsTranscript: 0,
                packageAnalyticsBatchTranscript: 0,
                packageAnalyticsVideo: 0,
                packageAnalyticsTranslate: 0,
                packageAnalyticsAI: 0,
                analyticsSpeechCapacity: "30",
                analyticsTranscriptCapacity: "30",
                analyticsBatchTranscriptCapacity: "30",
                analyticsVideoCapacity: "30",
                analyticsTranslateCapacity: "30",
                analyticsAICapacity: "20000000",
                packageExport: 0,
                addOnFullChat: 0,
                addOnZoom: 0,
                addOnRingcentral: 0,
                addOnCloud9: 0,
                addOnDynamics: 0,
                addOnWebex: 0,
                addOnGenesys: 0,
                addOnCompliance: 0,
                addOnQualityManagement: 0,
                addOnRealTimeTranscript: 0,
                addOnAnalytics: 0,
                addOnAIEntry: 0,
                addOnLeapXpert: 0,
                addOnMsftTeamsVoice: 0,
                addOnEmail: 0,
                addOnMsftTeamsUC: 0,
                addOnN1Mapping: 0,
                contractNumber: "",
                mailAlarming: "",
                commercialContactMail: "",
                exportType: "No",
                exportStorage: "",
                type: "",
                keyManagementType: "No",
                keySecurity: "Aes128",
                rotationType: "Interval",
                intervalDays: 365,
                activationDelay: 0,
                willExpire: false,
                expireDays: 0,
                customEncryptionKeyVaultUrl: "",
                customEncryptionKeySecretName: "",
                manualCreationCustom: false,
                manualCreationKeyRotation: false,
                isChanged: false,
                bulkImport: false,
                bulkLicense: "0",
                bulkRuleRecording: "",
                bulkRuleReplay: "",
                bulkRuleAccess: "",
                bulkRuleAnalytics: "",
                bulkUserList: "",
                bulkImportText: "",
                deleteTenantText: "",
                deleteTenant: "",
                deleteTenantMetadataText: "",
                deleteTenantMetadata: "",
                deleteTenantMetadataDate: new Date('0001-01-01'),
                deletePassword: "",
                insertMessage: "",
                insertMessageContent: "",
                insertMessageText: "",
                country: "",
                partner: "",
                onboardingDate: new Date('1901-01-01'),
                billingDate: new Date('1901-01-01'),
                trainingDate: new Date('1901-01-01'),
                supportNotes: "",
                systemId: "",
                bots: [],
                support: "",
                partnerContract: "",
                showExportPanel: false,
                showImportPanel: false,
                showAudioStoragePanel: false,
                audioStorageOverride: null,
                isSaving: false,
                botVisible: false,
                keyManagementEnabled: true,
                chatModelA: false,
                showTicketPage: false,
                validateKeyVault: "",
                domainRestrictionsList: "",
                isChecked: false,
                showModal: false,
                packageImport: 0,
                tenantSuspensionConvDelProcess: false,
                deletionNotifyMessage: false,
                packageArchive: 0,
                maxTtlFound: 0,
                keyExpirationConfirmed: true,
                awsAccessKeyId: "",
                awsSecretAccess: "",
                awsBucketName: "",
                awsRegion: "",
                awsServiceUrl: "",
                awsType: "",
                asymmetricKeyEnabled: false,
                hsm: false,
                keyType: "",
                keySetting: "",
                asymmetricKeyFileName: "",
                uploadedContent: "",
                selectedFile: false,
                asymmetricKeyButtonText: "createAsymmetricKey",
                interactionLogging: false,
                loggingStartDate: null,
                loggingStopDate: null,
                allowedUsers: [],
                checkboxAILogging: false,
                interactionTeachingBubble: false,
                processingRegion: "North Europe",
                eventHubVisible: false,
                eventHubNamespace: "",
                eventHubName: "",
                validateEventHubUrl: "false",
                kafkaVisible: false,
                kafkaBootstrapServers: "",
                kafkaTopic: "",
                kafkaSecurityProtocol: "",
                kafkaSslCaLocation: "",
                kafkaSslCertificateLocation: "",
                kafkaSslKeyLocation: "",
                kafkaSslKeyPassword: "",
                kafkaSaslMechanism: "",
                kafkaSaslUsername: "",
                kafkaSaslPassword: "",
                validateKafkaUrl: "false",
                checkTenantForDelete: undefined,
                checkTenantForDeleteError: "",
                deleteTenantMetadataStatus: undefined,
                error: {},
                createSubUnit: false


            }
        }
    }

    styles = {
        root: {
            paddingTop: "20px"
        }
    };
    toastyy = {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    };
    toastyy2 = {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true
    };






    checkS3StorageConnection = async () => {
        this.setState({ s3Check: "pending" });
        document.getElementById("checkS3Btn").style.border = "";

        var data = await this.props.apol
            .mutate({
                mutation: checkS3StorageConnection,
                variables: {
                    id: this.state.awsAccessKeyId,
                    secret: this.state.awsSecretAccess,
                    region: this.state.awsRegion,
                    bucket: this.state.awsBucketName,
                    awsServiceUrl: this.state.awsServiceUrl,
                    awsType: this.state.awsType
                }
            });
        if (data.data.checkS3StorageConnection) {
            document.getElementById("checkS3Btn").style.border = "2px solid green";
            this.setState({ s3Check: "true" });

        } else {
            document.getElementById("checkS3Btn").style.border = "2px solid red";
            this.setState({ s3Check: "false" });
        }
    }

    saveDisableCheck = () => {
        let checkForS3 = true;

        // S3 validation
        let check = this.state.s3Check;
        if (check === "false" || check === "pending") {
            checkForS3 = false;
        }
        if ((check === "" || check === "true") && this.state.storage === "S3Storage") {
            checkForS3 = true;
        }

        // Validation errors
        const errors = this.validateFields();
        const hasValidationErrors = Object.keys(errors).length > 0;

        if (this.state.isChanged && this.state.keyExpirationConfirmed && checkForS3 && !hasValidationErrors) {
            return false; // Save button is enabled
        }
        return true; // Save button is disabled
    }

    disbaledCheckValidity = () => {
        if (this.state.s3Check == "pending") {
            return true;
        }
        if (this.state.awsAccessKeyId !== "" && this.state.awsAccessKeyId !== null && this.state.awsSecretAccess !== "" && this.state.awsSecretAccess !== null && this.state.awsBucketName !== "" && this.state.awsBucketName !== null) {
            if (this.state.awsType === "Cloud" && this.state.awsRegion !== "" && this.state.awsRegion !== null) {
                return false
            } else if (this.state.awsType === "OnPremise" && this.state.awsServiceUrl !== "" && this.state.awsServiceUrl !== null) {
                return false
            }
        }
        return true;
    }


    onFileUploadAsymmetricKey = (event, state) => {

        let activeFile = event.target.files[0];

        if (activeFile) {

            this.setState({ selectedFile: true });

        }

        if (event.target.files[0]) {
            this.loadFile(event.target.files[0], state);
            this.setState({ asymmetricKeyFileName: event.target.files[0].name });
        }

        this.setState({ asymmetricKeyButtonText: "createAsymmetricKey" })
    };

    loadFile = async (file, state) => {
        let text = await file.text();
        this.setState({ [state]: text });
    }

    preventNegativeInput = (event) => {
        if (event.key === '-' || event.key === 'e' || event.key === 'E') {
            event.preventDefault();
        }
    }

    validateFields(state = this.state) {
        const errors = {};

        // Name
        if (!state.name || state.name.trim() === "") {
            errors.name = "fieldRequired";
        } else if (
            Array.isArray(this.props.tenantNamesList) &&
            this.props.tenantNamesList
                .filter(n => n && typeof n === 'string' && n.trim() !== "")
                .some(
                    n =>
                        n.trim().toLowerCase() === state.name.trim().toLowerCase() &&
                        //exclude current tenant if editing
                        (!this.props.data || (this.props.data && this.props.data.name.trim().toLowerCase() !== state.name.trim().toLowerCase()))
                )
        ) {
            errors.name = "nameAlreadyExists";
        }

        // Tenant ID
        if (!this.props.data) {
            if (!state.tenantId || state.tenantId.trim() === "") {
                errors.tenantId = "fieldRequired";
            } else if (!isValidUUID(state.tenantId)) {
                errors.tenantId = "tenantIdInvalid";
            }
        }

        // Admin ID
        if (!this.props.data) {
            if (!state.adminId || state.adminId.trim() === "") {
                errors.adminId = "fieldRequired";
            } else if (!isValidUUID(state.adminId)) {
                errors.adminId = "adminIdInvalid";
            }
        }

        // Type
        if (!state.type || state.type.trim() === "" || state.type === "Unknown") {
            errors.type = "fieldRequired";
        }


        // Storage
        let skipStorageError = false;
        if (
            this.props.data !== null &&
            this.props.data !== undefined &&
            (this.props.data.storageId === null || this.props.data.storageId === "") &&
            this.props.data.storage &&
            this.props.data.storage !== "" &&
            this.props.data.storage !== "Unknown"
        ) {
            skipStorageError = true;
        }

        if (!skipStorageError) {
            if (!state.storage || state.storage.trim() === "" || state.storage === "Unknown") {
                errors.storage = "fieldRequired";
            } else if (typeof state.storage === "string" && state.storage.length <= 1) {
                errors.storage = "fieldRequired";
            }
        }

        // Mail Alarming
        if (this.props.userRules.access !== "Order") {
            if (!state.mailAlarming || state.mailAlarming.trim() === "") {
                errors.mailAlarming = "fieldRequired";
            } else {
                // Split by comma, trim, and validate each email
                const emails = state.mailAlarming.split(",").map(e => e.trim()).filter(e => e !== "");
                const invalid = emails.some(email => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
                if (invalid) {
                    errors.mailAlarming = "invalidEmail";
                }
            }
        }

        // License: at least one must be > 0
        const licenseFields = [
            'license1', 'license2', 'license3', 'license4', 'license5',
            'license6', 'license7', 'license8', 'license9', 'license10', 'license11', 'license12', 'license13'
        ];
        const hasAtLeastOneLicense = licenseFields.some(key => parseInt(state[key], 10) > 0);
        if (!hasAtLeastOneLicense) {
            errors.license = "atLeastOneLicenseRequired";
        }

        return errors;
    }
    render() {
        let auth = this.props.authorization;
        return (<Stack vertical>
            <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "name")}</>)}</MyContext.Consumer>}
                onChange={(event) => { this.handleChange(event.target.value, 0) }}
                value={this.state.name}
                errorMessage={this.state.error.name && <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", this.state.error.name)}</>)}</MyContext.Consumer>}
                required
            />
            <Stack.Item styles={this.styles}>
                <Stack>
                    <Stack.Item>
                        <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "tenantId")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 1) }}
                            value={this.state.tenantId}
                            onKeyDown={this._handleKeyDown}
                            errorMessage={this.state.error.tenantId && <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", this.state.error.tenantId)}</>)}</MyContext.Consumer>}
                            required
                            disabled={(this.props.data !== null && this.props.data !== undefined)}
                        />

                    </Stack.Item>
                    {this.state.cloudTenantId &&
                        <Stack.Item>
                            <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "cloudTenantId")}</>)}</MyContext.Consumer>}
                                value={this.state.cloudTenantId}
                                disabled
                            />

                        </Stack.Item>
                    }
                    <Stack.Item>

                        <TextField label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "adminId")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 2) }}
                            value={this.state.adminId}
                            onKeyDown={this._handleKeyDown}
                            disabled={(this.props.data !== null && this.props.data !== undefined)}
                            errorMessage={this.state.error.adminId && <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", this.state.error.adminId)}</>)}</MyContext.Consumer>}
                            required

                        />
                    </Stack.Item>
                    <br />
                    <br />
                    <hr />
                    {this.state.error.license && (
                        <span style={{ color: "#a4262c", fontSize: 12 }}>
                            {this.context.getTranslation("tenants", this.state.error.license)}
                        </span>
                    )}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.license6} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceVoiceRec")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 57) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license1} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceRec")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 3) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license8} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartVoice")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 60) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license3} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartRec")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 10) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license13} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseEntryVoiceRecording")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 103) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license11} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseSmartBase")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 97) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license12} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseComplianceBase")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 99) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license5} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "chatRecordingStandalone")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 12) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license10} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 84) }}
                        />
                    </Stack.Item>}


                    <br />
                    {this.props.userRules.ruleAccess.tenantCreate && <>
                        <br />
                        <hr />
                    </>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnMsftTeamsVoice} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsVoice")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 100) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnMsftTeamsUC} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsUC")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 101) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.addOnAnalytics} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAnalytics")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 62) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.addOnAIEntry} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAIEntry")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 117) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnCompliance} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCompliance")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 72) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>

                        <TextField min={0} value={this.state.addOnQualityManagement} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnQualityManagement")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.setState({ addOnQualityManagement: event.target.value, isChanged: true }) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>

                        <TextField min={0} value={this.state.addOnRealTimeTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRealTimeTranscript")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.setState({ addOnRealTimeTranscript: event.target.value, isChanged: true }) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnFullChat} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnFullChat")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 63) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnDynamics} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnDynamics")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 71) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnEmail} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnEmail")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 104) }}
                        />
                    </Stack.Item>}
                    <br />
                    {this.props.userRules.ruleAccess.tenantCreate && <>
                        <br />
                        <hr />
                    </>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.packageAnalyticsTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranscript")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 59) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsBatchTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageBatchTranscript")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 96) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsTranslate} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranslate")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 19) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsAI} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaAI")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 76) }}
                        />
                    </Stack.Item>}
                    <br />
                    {this.props.userRules.ruleAccess.tenantCreate && <>
                        <br />
                        <hr />
                    </>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.packageStorage} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageStorage")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 14) }}
                        />
                    </Stack.Item>}
                    {<Stack.Item styles={this.styles}>
                        <TextField min={0} disabled={!this.props.userRules.ruleAccess.tenantCreate} value={this.state.packageArchive} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageArchive")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 74) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageExport} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageExport")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 16) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageImport} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageImport")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 73) }}
                        />
                    </Stack.Item>}
                    <br />
                    {this.props.userRules.ruleAccess.tenantCreate && <>
                        <br />
                        <hr />
                    </>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.addOnZoom} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnZoom")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 68) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.addOnGenesys} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnGenesys")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 69) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnRingcentral} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRingcentral")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 70) }}
                        />
                    </Stack.Item>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnCloud9} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCloud9")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, "addOnCloud9") }}
                        />
                    </Stack.Item>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnLeapXpert} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnLeapXpert")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 83) }}
                        />
                    </Stack.Item>}


                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.addOnN1Mapping} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnN1Mapping")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 118) }}
                        />
                    </Stack.Item>}

                    <br />
                    {this.props.userRules.ruleAccess.tenantCreate && <>
                        <br />
                        <hr />
                    </>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField min={0} value={this.state.license7} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceVoiceRecAna")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 58) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} int value={this.state.license2} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceRecAna")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 4) }}
                        />
                    </Stack.Item>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license4} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartRecAna")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 11) }}
                        />
                    </Stack.Item>}

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.license9} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartVoiceAna")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 61) }}
                        />
                    </Stack.Item>}


                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsVideo} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaVideo")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 15) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField min={0} value={this.state.packageAnalyticsSpeech} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaSpeech")}</>)}</MyContext.Consumer>}
                            onKeyDown={this.preventNegativeInput}
                            onChange={(event) => { this.handleChange(event.target.value, 18) }}
                        />
                    </Stack.Item>}
                    {(this.props.userRules.ruleAccess.tenantCreate && !this.props.userRules.isAscUser) && <>
                        <br />
                        <hr />
                    </>}

                    {this.props.userRules.isAscUser && <>
                        <br/>
                        <hr />
                        <Stack.Item styles={this.styles}>
                            <TextField min={0} value={this.state.analyticsVideoCapacity} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "analyticsVideoCapacity")}</>)}</MyContext.Consumer>}
                                onKeyDown={this.preventNegativeInput}
                                onChange={(event) => { this.handleChange(event.target.value, 123) }}
                            />
                        </Stack.Item>
                        <Stack.Item styles={this.styles}>
                            <TextField min={0} value={this.state.analyticsSpeechCapacity} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "analyticsSpeechCapacity")}</>)}</MyContext.Consumer>}
                                onKeyDown={this.preventNegativeInput}
                                onChange={(event) => { this.handleChange(event.target.value, 120) }}
                            />
                        </Stack.Item>
                        <Stack.Item styles={this.styles}>
                            <TextField min={0} value={this.state.analyticsTranscriptCapacity} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "analyticsTranscriptCapacity")}</>)}</MyContext.Consumer>}
                                onKeyDown={this.preventNegativeInput}
                                onChange={(event) => { this.handleChange(event.target.value, 121) }}
                            />
                        </Stack.Item>
                        <Stack.Item styles={this.styles}>
                            <TextField min={0} value={this.state.analyticsBatchTranscriptCapacity} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "analyticsBatchTranscriptCapacity")}</>)}</MyContext.Consumer>}
                                onKeyDown={this.preventNegativeInput}
                                onChange={(event) => { this.handleChange(event.target.value, 122) }}
                            />
                        </Stack.Item>
                        <Stack.Item styles={this.styles}>
                            <TextField min={0} value={this.state.analyticsTranslateCapacity} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "analyticsTranslateCapacity")}</>)}</MyContext.Consumer>}
                                onKeyDown={this.preventNegativeInput}
                                onChange={(event) => { this.handleChange(event.target.value, 124) }}
                            />
                        </Stack.Item>
                        <Stack.Item styles={this.styles}>
                            <TextField min={0} value={this.state.analyticsAICapacity} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "analyticsAICapacity")}</>)}</MyContext.Consumer>}
                                onKeyDown={this.preventNegativeInput}
                                onChange={(event) => { this.handleChange(event.target.value, 125) }}
                            />
                        </Stack.Item>
                        <br />
                        <hr />
                    </>}
                   




                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item>
                        <TextField value={this.state.contractNumber} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "contractNo")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 20) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField value={this.state.country} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "country")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 22) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && this.props.userRules.access != "Partner" && <Stack.Item styles={this.styles}>
                        <TextField value={this.state.partner} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partner")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 25) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && this.state.partner && <Stack.Item styles={this.styles}>
                        <Checkbox
                            id={"showTicketPage"}
                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "showTicketPage")}</>)}</MyContext.Consumer>}
                            checked={this.state.showTicketPage}
                            onChange={(event, newValue) => {
                                this.handleChange(newValue, 116);
                            }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField value={this.state.partnerContract} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partnerContract")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 26) }}
                        />
                    </Stack.Item>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack.Item styles={this.styles}>
                        <TextField value={this.state.support} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "support")}</>)}</MyContext.Consumer>}
                            onChange={(event) => { this.handleChange(event.target.value, 27) }}
                        />
                    </Stack.Item>}
                    {true && <Stack>
                        <Stack.Item styles={this.styles}>
                            <Checkbox
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "botUsage")}</>)}</MyContext.Consumer>}
                                value={this.state.botVisible}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        botVisible: newValue
                                    });
                                }}
                            />
                        </Stack.Item>
                    </Stack>}
                    {this.props.userRules.ruleAccess.tenantCreate && this.props.userRules.access != "Partner" && this.state.botVisible && <Stack>

                        <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '8px', alignItems: 'center' }}>
                            {Array.isArray(this.state.bots) && this.state.bots.map((bot, idx) => [
                                <Label key={'label-' + (bot.id || idx)} styles={{ root: { minWidth: 120, textAlign: 'left' } }}>{bot.name}</Label>,
                                <TextField
                                    key={'input-' + (bot.id || idx)}
                                    type="number"
                                    min={0}
                                    value={bot.count}
                                    onKeyDown={this.preventNegativeInput}
                                    onChange={e => {
                                        const val = e.target.value.includes('-') ? 0 : Number(e.target.value);
                                        const newBots = [...this.state.bots];
                                        newBots[idx] = { ...bot, count: val };
                                        this.setState({ bots: newBots });
                                        this.handleChange(e.target.value, 29)
                                    }}
                                    styles={{ root: { width: 80, textAlign: 'left' } }}
                                />
                            ])}
                        </div>
                    </Stack>}
                    {!this.props.userRules.ruleAccess.tenantCreate && this.props.userRules.ruleAccess.tenantChange && this.state.botVisible && <Stack>

                        <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '8px', alignItems: 'center' }}>
                            {Array.isArray(this.state.bots) && this.state.bots.map((bot, idx) => [
                                <Label key={'label-' + (bot.id || idx)} styles={{ root: { minWidth: 120, textAlign: 'left' } }}>{bot.name}</Label>,
                                <TextField
                                    key={'input-' + (bot.id || idx)}
                                    type="number"
                                    value={bot.count}
                                    styles={{ root: { width: 80, textAlign: 'left' } }}
                                    disabled
                                />
                            ])}
                        </div>
                    </Stack>}
                    {(this.props.userRules.ruleAccess.tenantCreate
                        || this.props.userRules.access == "Partner"
                        || this.props.userRules.access == "Order"
                        || this.props.userRules.access == "Support")
                        && <Stack.Item styles={this.styles}>
                            <Stack.Item>
                                <div>Onboarding Date</div>
                                <DatePicker
                                    onSelectDate={(date) => {
                                        this.handleChange(date, 23)
                                    }}
                                    value={this.state.onboardingDate}
                                />
                                <div>Training Date</div>
                                <DatePicker
                                    onSelectDate={(date) => {
                                        this.handleChange(date, 65)
                                    }}
                                    value={this.state.trainingDate}
                                />
                                <div>BillingDate</div>
                                <DatePicker
                                    onSelectDate={(date) => {
                                        this.handleChange(date, 24)
                                    }}
                                    value={this.state.billingDate}
                                />
                            </Stack.Item>
                            <Stack.Item styles={this.styles}>
                                <TextField value={this.state.supportNotes} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "supportNotes")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 66) }}
                                />
                            </Stack.Item>
                            <Stack.Item styles={this.styles}>
                                <TextField value={this.state.systemId} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "systemId")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 67) }}
                                />
                            </Stack.Item>
                        </Stack.Item>}

                    {!this.props.userRules.ruleAccess.tenantCreate && <Stack>

                        {this.state.license6 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license6} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceVoiceRec")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license1 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license1} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceRec")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license8 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license8} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartVoice")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license3 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license3} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartRec")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license13 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license13} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseEntryVoiceRecording")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license11 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license11} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseSmartBase")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license12 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license12} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseComplianceBase")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {this.state.license5 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license5} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "chatRecordingStandalone")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license10 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license10} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {(this.state.license6 > 0 || this.state.license1 > 0 || this.state.license8 > 0 || this.state.license3 > 0 || this.state.license5 > 0 || this.state.license10 > 0 || this.state.license11 > 0 || this.state.license12 > 0 || this.state.license13 > 0 || this.state.license14 > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.addOnMsftTeamsVoice > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnMsftTeamsVoice} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsVoice")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnMsftTeamsUC > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnMsftTeamsUC} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsUC")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnAnalytics > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.addOnAnalytics} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAnalytics")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnAIEntry > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.addOnAIEntry} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAIEntry")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnCompliance > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnCompliance} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCompliance")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnQualityManagement > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnQualityManagement} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnQualityManagement")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnRealTimeTranscript > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnRealTimeTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRealTimeTranscript")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnFullChat > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnFullChat} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnFullChat")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnDynamics > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnDynamics} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnDynamics")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnEmail > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnEmail} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnEmail")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {(this.state.addOnAnalytics > 0 || this.state.addOnAIEntry > 0 || this.state.addOnCompliance > 0 || this.state.addOnQualityManagement > 0 || this.state.addOnRealTimeTranscript > 0 || this.state.addOnFullChat > 0 || this.state.addOnDynamics > 0 || this.state.addOnMsftTeamsVoice > 0 || this.state.addOnMsftTeamsUC > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.packageAnalyticsTranscript > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.packageAnalyticsTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranscript")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageAnalyticsBatchTranscript > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.packageAnalyticsBatchTranscript} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageBatchTranscript")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageAnalyticsTranslate > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageAnalyticsTranslate} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaTranslate")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageAnalyticsAI > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageAnalyticsAI} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaAI")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {(this.state.packageAnalyticsTranscript > 0 || this.state.packageAnalyticsBatchTranscript > 0 || this.state.packageAnalyticsTranslate > 0 || this.state.packageAnalyticsAI > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.packageStorage > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.packageStorage} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageStorage")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageArchive > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageArchive} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageArchive")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {this.state.packageExport > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageExport} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageExport")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageImport > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageImport} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageImport")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {(this.state.packageStorage > 0 || this.state.packageArchive > 0 || this.state.packageExport > 0 || this.state.packageImport > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.addOnZoom > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnZoom} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnZoom")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnWebex > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnWebex} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnWebex")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnGenesys > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnGenesys} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnGenesys")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnRingcentral > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnRingcentral} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRingcentral")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.addOnCloud9 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnCloud9} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCloud9")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }


                        {this.state.addOnLeapXpert > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnLeapXpert} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnLeapXpert")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {this.state.addOnN1Mapping > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.addOnN1Mapping} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnN1Mapping")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {(this.state.addOnZoom > 0 || this.state.addOnGenesys > 0 || this.state.addOnRingcentral > 0 || this.state.addOnLeapXpert > 0 || this.state.addOnN1Mapping > 0 || this.state.addOnWebex > 0 || this.state.addOnCloud9 > 0) && <>
                            <br />
                            <hr />
                        </>}

                        {this.state.license7 > 0 ?
                            <Stack.Item>
                                <TextField min={0} value={this.state.license7} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceVoiceRecAna")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license2 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license2} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "complianceRecAna")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.license4 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license4} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartRecAna")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }

                        {this.state.license9 > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.license9} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "smartVoiceAna")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }


                        {this.state.packageAnalyticsVideo > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageAnalyticsVideo} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaVideo")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {this.state.packageAnalyticsSpeech > 0 ?
                            <Stack.Item styles={this.styles}>
                                <TextField min={0} value={this.state.packageAnalyticsSpeech} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "packageAnaSpeech")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>
                            : <div></div>
                        }
                        {(this.state.license7 > 0 || this.state.license2 > 0 || this.state.license4 > 0 || this.state.license9 > 0 || this.state.packageAnalyticsVideo > 0 || this.state.packageAnalyticsSpeech > 0) && <>
                            <br />
                            <hr />
                        </>}


                        {(!this.props.userRules.ruleAccess.tenantCreate && this.props.userRules.access != "Order"
                            && this.props.userRules.access != "Partner"
                            && this.props.userRules.access != "Support") &&
                            < Stack.Item>
                                <TextField value={this.state.contractNumber} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "contractNo")}</>)}</MyContext.Consumer>} disabled />
                            </Stack.Item>}
                        {(this.props.userRules.ruleAccess.tenantCreate || this.props.userRules.access == "Order"
                            || this.props.userRules.access == "Partner"
                            || this.props.userRules.access == "Support")
                            && <Stack>
                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.contractNumber} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "contractNo")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 20) }}
                                    />
                                </Stack.Item>
                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.country} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "country")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 22) }}
                                    />
                                </Stack.Item>
                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.partner} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partner")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 25) }}
                                    />
                                </Stack.Item>
                                {this.state.partner && <Stack.Item styles={this.styles}>
                                    <Checkbox
                                        id={"showTicketPage2"}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "showTicketPage")}</>)}</MyContext.Consumer>}
                                        checked={this.state.showTicketPage}
                                        onChange={(event, newValue) => {
                                            this.handleChange(newValue, 116);
                                        }}
                                    />
                                </Stack.Item>}
                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.partnerContract} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "partnerContract")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 26) }}
                                    />
                                </Stack.Item>
                                <Stack.Item styles={this.styles}>
                                    <TextField value={this.state.support} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "support")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => { this.handleChange(event.target.value, 27) }}
                                    />
                                </Stack.Item>
                            </Stack>}
                    </Stack>}

                    {(this.props.userRules.ruleAccess.tenantCreate
                        || this.props.userRules.access == "Order"
                        || this.props.userRules.access == "Support") &&
                        <Stack.Item>
                            <ComboBox
                                style={{ width: "300px" }}
                                placeholder="Select an option"
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "customerType")}</>)}</MyContext.Consumer>}
                                unknown
                                Europa
                                USA
                                Asia
                                options={[
                                    {
                                        key: "Paid",
                                        text: "Paid",
                                    },
                                    {
                                        key: "Trial",
                                        text: "End Customer Trial",
                                    },
                                    {
                                        key: "Partner",
                                        text: "Partner Trial",
                                    }]
                                }
                                selectedKey={this.state.type}
                                onChange={(event, option, index, newValue) => { this.handleChange(option.key, 13) }}
                                errorMessage={this.state.error.type ? this.context.getTranslation("tenants", this.state.error.type) : undefined}
                                required
                            />
                        </Stack.Item>}

                    {this.props.userRules.access == "Order" &&
                        <Stack>
                            <Stack.Item>
                                <Query
                                    query={getStorageData}
                                    variables={{}}
                                >
                                    {({ loading, error, data }) => {
                                        if (loading) {
                                            return (
                                                <div style={{ float: "left", "margin-left": "50px" }}>
                                                    <Spinner label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "loading")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                                </div>
                                            );
                                        }


                                        if (error) return <h4>Failed to connect</h4>;
                                        if (data.getStorageData == null) {
                                            return <div />;
                                        }

                                        let storagesList = [];
                                        if (data.getStorageData != null) {
                                            for (var i = 0; i < data.getStorageData.length; i++) {
                                                storagesList.push({
                                                    key: data.getStorageData[i].id,
                                                    text: data.getStorageData[i].displayName,
                                                    disabled: false

                                                });
                                            }

                                        }

                                        return <Dropdown
                                            label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "regionalStorage")}</>)}</MyContext.Consumer>}
                                            placeholder={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "selectAnOption")}</>)}</MyContext.Consumer>}
                                            onChange={(event, option, index, newValue) => { this.handleChange(option.key, 5) }}
                                            defaultSelectedKey={this.state.storage}
                                            options={storagesList}
                                        />

                                    }}

                                </Query>
                            </Stack.Item>
                        </Stack>
                    }

                    {this.props.userRules.access != "Order" &&
                        <Stack>
                            <Stack.Item styles={this.styles}>
                                <TextField value={this.state.domainRestrictionsList} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "domainRestrictionsList")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => {
                                        this.handleChange(event.target.value, 64)
                                    }}
                                    placeholder="exampleDomain.com, example_domain.com, example_eu.com"
                                />
                            </Stack.Item>
                            <Stack.Item styles={this.styles}>
                                <TextField value={this.state.mailAlarming} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "mailAlarming")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 17) }}
                                    errorMessage={this.state.error.mailAlarming && <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", this.state.error.mailAlarming)}</>)}</MyContext.Consumer>}
                                    required
                                />
                            </Stack.Item>
                            <Stack.Item styles={this.styles}>
                                <TextField value={this.state.commercialContactMail} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "commercialContactMail")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => {
                                        const emailValue = event.target.value;
                                        if (emailValue.includes(',') || emailValue.includes(';') || emailValue.includes(' ')) {
                                            const singleEmail = emailValue.split(/[,;\s]/)[0];
                                            this.handleChange(singleEmail, 102);
                                        } else {
                                            this.handleChange(emailValue, 102);
                                        }
                                    }}
                                    disabled={true} //the information in this field it will be populated with the information from Dynamics Entitlement and only Service Admin can perform this action
                                />
                            </Stack.Item>
                            <br />
                            <Stack.Item>
                                <Query
                                    query={getStorageData}
                                    variables={{}}
                                >
                                    {({ loading, error, data }) => {
                                        if (loading) {
                                            return (
                                                <div style={{ float: "left", "margin-left": "50px" }}>
                                                    <Spinner label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "loading")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                                </div>
                                            );
                                        }


                                        if (error) return <h4>Failed to connect</h4>;
                                        if (data.getStorageData == null) {
                                            return <div />;
                                        }

                                        let storagesList = [];
                                        if (data.getStorageData != null) {
                                            for (var i = 0; i < data.getStorageData.length; i++) {

                                                storagesList.push({
                                                    key: data.getStorageData[i].id,
                                                    text: data.getStorageData[i].displayName,
                                                });
                                            }

                                        }

                                        return <Dropdown
                                            label={<MyContext.Consumer>{(context) => (<>{context.getTranslation("tenants", "globalStorage")}</>)}</MyContext.Consumer>}
                                            placeholder={<MyContext.Consumer>{(context) => (<>{context.getTranslation("common", "selectAnOption")}</>)}</MyContext.Consumer>}
                                            onChange={(event, option, index, newValue) => { this.handleChange(option.key, 5) }}
                                            defaultSelectedKey={this.state.storage}
                                            options={storagesList}
                                            required
                                            errorMessage={this.state.error.storage ? this.context.getTranslation("tenants", this.state.error.storage) : undefined}

                                        />

                                    }}

                                </Query>
                                {/*display old storage if new storage is null------------------------------------------------------------------------------------------*/}
                                {(this.props.data !== null && (this.props.data.storageId === null || this.props.data.storageId === "")) && <>
                                    <ComboBox
                                        style={{ width: "300px" }}
                                        disabled={true}
                                        placeholder="Select an option"
                                        label="Old Storage"
                                        options={[{
                                            key: "Unknown",
                                            text: "Unknown"
                                        },
                                        {
                                            key: "Emea",
                                            text: "EMEA GRS",
                                        },
                                        {
                                            key: "UkSouth",
                                            text: "UK South GRS",
                                        },
                                        {
                                            key: "Apac",
                                            text: "APAC GRS",
                                        },
                                        {
                                            key: "Americas",
                                            text: "Americas GRS",
                                        },
                                        {
                                            key: "Brazil",
                                            text: "Brazil GRS",
                                        },
                                        {
                                            key: "Canada",
                                            text: "Canada GRS",
                                        },
                                        {
                                            key: "Japan",
                                            text: "Japan GRS",
                                        },
                                        {
                                            key: "Switzerland",
                                            text: "Switzerland GRS",
                                        },
                                        {
                                            key: 'UAENorth',
                                            text: "UAE North GRS"
                                        },

                                        {
                                            key: "LrsEmea",
                                            text: "EMEA LRS",
                                        },
                                        {
                                            key: "LrsUkSouth",
                                            text: "UK South LRS",
                                        },
                                        {
                                            key: "LrsApac",
                                            text: "APAC LRS",
                                        },
                                        {
                                            key: "LrsAmericas",
                                            text: "Americas LRS",
                                        },
                                        {
                                            key: "LrsBrazil",
                                            text: "Brazil LRS",
                                        },
                                        {
                                            key: "LrsCanada",
                                            text: "Canada LRS",
                                        },
                                        {
                                            key: "LrsJapan",
                                            text: "Japan LRS",
                                        },
                                        {
                                            key: "LrsSwitzerland",
                                            text: "Switzerland LRS",
                                        },
                                        {
                                            key: 'LrsUAENorth',
                                            text: "UAE North LRS"
                                        },
                                        {
                                            key: "GrsSwiss",
                                            text: "Swiss GRS",
                                        },
                                        {
                                            key: "ZrsSingapore",
                                            text: "Singapore Zrs",
                                        },
                                        {
                                            key: "CustomStorage",
                                            text: "Own Storage",
                                        }]
                                        }
                                        selectedKey={this.props.data.storage}
                                    />


                                    {this.props.data.storage === 'S3Storage' && <>
                                        <ComboBox
                                            style={{ width: "300px" }}
                                            placeholder="Select an option"
                                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsType")}</>)}</MyContext.Consumer>}
                                            options={[
                                                { key: "Cloud", text: "Cloud" },
                                                { key: "OnPremise", text: "On-premise" },

                                            ]}
                                            selectedKey={this.state.awsType}
                                            onChange={(ev, newVal) => {
                                                this.setState({
                                                    awsType: newVal.key,
                                                    changed: true
                                                });
                                            }}
                                            disabled={true}
                                        />
                                        <TextField
                                            type={"text"}
                                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsAccessKeyId")}</>)}</MyContext.Consumer>}
                                            value={this.state.awsAccessKeyId}
                                            onChange={(event) => { this.handleChange(event.target.value, 77) }}
                                            disabled={true}

                                        />
                                        <TextField
                                            type={"text"}
                                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsSecretAccess")}</>)}</MyContext.Consumer>}
                                            value={this.state.awsSecretAccess}
                                            onChange={(event) => { this.handleChange(event.target.value, 78) }}
                                            disabled={true}

                                        />
                                        {this.state.awsType == "OnPremise" &&
                                            <TextField
                                                type={"text"}
                                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsServiceUrl")}</>)}</MyContext.Consumer>}
                                                value={this.state.awsServiceUrl}
                                                onChange={(event, newValue) => {
                                                    this.setState({
                                                        awsServiceUrl: newValue,
                                                        changed: true
                                                    });
                                                }}
                                                disabled={true}

                                            />}
                                        <TextField
                                            type={"text"}
                                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "awsBucketName")}</>)}</MyContext.Consumer>}
                                            value={this.state.awsBucketName}
                                            onChange={(event) => { this.handleChange(event.target.value, 79) }}
                                            disabled={true}

                                        />
                                        {this.state.awsType === "Cloud" &&
                                            <Query
                                                query={queryGetAWSRegions}
                                                variables={this.props.authorization} >
                                                {({ loading, error, data }) => {
                                                    if (loading) return <div>
                                                        <Spinner label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "loadingRegions")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                                    </div>;
                                                    if (error) return <h1> </h1>;

                                                    if (data.getAWSRegions == null) {
                                                        return <div></div>;
                                                    }
                                                    this.tmpKey = [];
                                                    const stack = data.getAWSRegions;
                                                    if (data.getAWSRegions != null) {
                                                        for (let x = 0; x < stack.length; x++) {
                                                            let i = {
                                                                key: stack[x].code,
                                                                text: stack[x].displayName,
                                                            };
                                                            this.tmpKey.push(i);
                                                        }
                                                    }

                                                    return <ComboBox
                                                        style={{ width: "300px" }}
                                                        placeholder="Select an option"
                                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "defaultRegion")}</>)}</MyContext.Consumer>}
                                                        options={this.tmpKey}
                                                        selectedKey={this.state.awsRegion}
                                                        onChange={(ev, newVal) => {
                                                            this.setState({
                                                                awsRegion: newVal.key,
                                                                isChanged: true
                                                            });
                                                        }}
                                                        disabled={true}

                                                    />
                                                }}
                                            </Query>}
                                        <br />
                                        <Stack.Item>
                                            <DefaultButton
                                                id="checkS3Btn"
                                                text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "checkValidity")}</>)}</MyContext.Consumer>}
                                                onClick={this.checkS3StorageConnection}
                                                disabled={this.disbaledCheckValidity()}
                                            />
                                        </Stack.Item>
                                    </>}

                                    {this.state.customStorage &&
                                        <TextField value={this.state.customStorage} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "storageConnectionString")}</>)}</MyContext.Consumer>}
                                            disabled
                                        />}
                                </>}
                                {/*end of old storage display------------------------------------------------------------------------------------------------------------------*/}


                            </Stack.Item>

                        </Stack>
                    }
                    {this.props.userRules.access != "Order" && this.state.keyManagementEnabled && < Stack >

                        <Stack.Item>
                            <MyContext.Consumer>
                                {(context) => (
                                    <ComboBox
                                        style={{ width: "300px" }}
                                        placeholder="Select an option"
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyManagement")}</>)}</MyContext.Consumer>}
                                        options={[{
                                            key: "No",
                                            text: context.getTranslation("tenants", "standard"),
                                        },
                                        {
                                            key: "KeyRotation",
                                            text: context.getTranslation("tenants", "keyRotation"),
                                        },
                                        {
                                            key: "CustomKey",
                                            text: context.getTranslation("tenants", "customKeys"),
                                        }]
                                        }
                                        selectedKey={this.state.keyManagementType}
                                        onChange={(event, option, index, newValue) => { this.handleChange(option.key, 48) }}
                                    />
                                )
                                }
                            </MyContext.Consumer>

                        </Stack.Item>


                        {/* Key creation */}

                        {this.state.keyManagementType == "CustomKey" &&
                            <Stack.Item styles={this.styles}>

                                <TextField id="keyVault" name="keyVault" value={this.state.customEncryptionKeyVaultUrl} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "customerKeyURL")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 50) }}
                                />
                                <span id="keyVaultError" style={{ "color": "red" }}></span>

                                <TextField id="secretName" name="secretName" value={this.state.customEncryptionKeySecretName} label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "customerSecretName")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.handleChange(event.target.value, 51) }}
                                />
                                <span id="secretError" style={{ "color": "red" }}></span>
                                <br />
                                <DefaultButton id="checkBtn" text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "checkValidity")}</>)}</MyContext.Consumer>} onClick={(event) => { this.checkCustomKeyVault(this.props.apol) }} />
                                <Modal
                                    isOpen={this.state.showModal}
                                    onDismiss={this._closeModal}
                                    isBlocking
                                    containerClassName={contentStyles.container}
                                >
                                    <div className={contentStyles.header}>
                                        <span><b><MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "warning")}</>)}</MyContext.Consumer></b></span>
                                        <IconButton
                                            styles={iconButtonStyles}
                                            iconProps={{ iconName: 'Cancel' }}
                                            ariaLabel="Close popup modal"
                                            onClick={this._closeModal}
                                        />
                                    </div>
                                    <div className={contentStyles.body}>
                                        <span>
                                            <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "secretDoesNotExist")}</>)}</MyContext.Consumer>
                                            <br />
                                            <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "createSecretQuestion")}</>)}</MyContext.Consumer>
                                        </span>
                                        <br />
                                        <span>
                                            <PrimaryButton
                                                text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "yes")}</>)}</MyContext.Consumer>}
                                                allowDisabledFocus={true}
                                                onClick={
                                                    () => {
                                                        this.createCustomKeySecret(this.props.apol);
                                                        this._closeModal();
                                                    }
                                                }
                                                styles={iconButtonStyles}
                                            />
                                            <PrimaryButton
                                                text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "cancel")}</>)}</MyContext.Consumer>}
                                                allowDisabledFocus={true}
                                                onClick={
                                                    () => {
                                                        this._closeModal();
                                                    }
                                                }
                                                styles={iconButtonStyles}
                                                style={{ background: "#edebeb", color: "black", border: "#edebeb", "margin-left": "5px" }}
                                            />
                                        </span>
                                    </div>
                                </Modal>
                            </Stack.Item>}
                        {/*asymetric keys*/}
                        {(this.state.keyManagementType !== "No" && this.state.storage !== "S3Storage") && <>
                            <br />
                            <Stack.Item>
                                <Checkbox
                                    label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "asymmetricKeyEnabled")}</>)}</MyContext.Consumer>}
                                    checked={this.state.asymmetricKeyEnabled}
                                    onChange={(event, newValue) => { this.handleChange(newValue, 80) }}
                                />
                            </Stack.Item>
                            {this.state.asymmetricKeyEnabled &&
                                <Stack.Item>

                                    <Dropdown
                                        style={{ width: "300px" }}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyType")}</>)}</MyContext.Consumer>}
                                        selectedKey={this.state.keyType}
                                        onChange={(event, option, index, newValue) => { this.handleChange(option.key, 81) }}
                                        options={[{ key: "RSA", text: "RSA" }]}
                                    />

                                    <Dropdown
                                        id="keySetting"
                                        style={{ width: "300px" }}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keySetting")}</>)}</MyContext.Consumer>}
                                        selectedKey={this.state.keySetting}
                                        onChange={(event, option, index, newValue) => {
                                            this.handleChange(option.key, 82)
                                            document.getElementById("keySettingError").innerHTML = "";
                                            document.getElementById("keySetting").style.border = "";
                                        }}
                                        options={[
                                            { key: "2048", text: "2048" },
                                            { key: "3072", text: "3072" },
                                            { key: "4096", text: "4096" },
                                        ]}

                                    />
                                    <span id="keySettingError" style={{ "color": "red" }}></span>
                                </Stack.Item>
                            }
                        </>}

                        {/* Asymmetric Key */}
                        {this.state.asymmetricKeyEnabled &&
                            <>
                                <br />
                                <Stack.Item>
                                    <Checkbox
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "hsmKeyEnabled")}</>)}</MyContext.Consumer>}
                                        checked={this.state.keyManagementType == "KeyRotation" ? false : this.props.hsm}
                                        onChange={(event, newValue) => { this.handleChange(newValue, 92) }}
                                        disabled={!(this.state.keyManagementType == "CustomKey" && this.state.asymmetricKeyEnabled)}
                                    />
                                    <br />
                                    <Button id="createKeyButton" text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", this.props.data.keyManagement.asymmetricKeySettings === null ? "createAsymmetricKeyButton" : "updateAsymmetricKeyButton")}</>)}</MyContext.Consumer>} onClick={(event) => { this.handleCreateAsymmetricKey(this.props.apol) }} disabled={this.state.TTLLoading} />
                                </Stack.Item></>}


                        {(this.state.keyManagementType == "KeyRotation" || this.state.keyManagementType == "CustomKey") &&
                            <Stack.Item styles={this.styles}>

                                {/* Key security */}
                                {!this.state.asymmetricKeyEnabled &&
                                    <ComboBox
                                        style={{ width: "300px" }}
                                        placeholder="Select an option"
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keySecurity")}</>)}</MyContext.Consumer>}
                                        options={[{
                                            key: "Aes128",
                                            text: "AES128"
                                        },
                                        {
                                            key: "Aes192",
                                            text: "AES192",
                                        },
                                        {
                                            key: "Aes256",
                                            text: "AES256",
                                        }]
                                        }
                                        selectedKey={this.state.keySecurity}
                                        onChange={(event, option, index, newValue) => { this.handleChange(option.key, 49) }}
                                    />
                                }
                                {/* Rotation Type */}
                                <MyContext.Consumer>
                                    {(context) => (
                                        <ComboBox
                                            style={{ width: "300px" }}
                                            placeholder="Select an option"
                                            label={context.getTranslation("tenants", "rotationType")}
                                            options={[{
                                                key: "No",
                                                text: context.getTranslation("tenants", "no"),
                                                disabled: this.state.asymmetricKeyEnabled

                                            },
                                            {
                                                key: "Interval",
                                                text: context.getTranslation("tenants", "interval"),
                                                disabled: this.state.asymmetricKeyEnabled
                                            },
                                            {
                                                key: "Manual",
                                                text: context.getTranslation("tenants", "manual"),
                                                disabled: this.state.asymmetricKeyEnabled
                                            }]
                                            }
                                            selectedKey={this.state.rotationType}
                                            onChange={(event, option, index, newValue) => { this.handleChange(option.key, 55) }}
                                            disabled={this.state.asymmetricKeyEnabled}
                                        />
                                    )
                                    }
                                </MyContext.Consumer>


                                {this.state.rotationType == "Manual" && <div>
                                    {!this.state.asymmetricKeyEnabled && <>

                                        <br />
                                        <Checkbox
                                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "manualCreation")}</>)}</MyContext.Consumer>}
                                            value={this.state.manualCreationKeyRotation}
                                            onChange={(event, newValue) => {
                                                this.setState({
                                                    manualCreationKeyRotation: newValue,
                                                    isChecked: newValue
                                                });
                                            }}
                                            checked={this.state.isChecked}
                                        />
                                        {this.state.manualCreationKeyRotation ? (
                                            <DefaultButton id="requestRotation" text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "requestForRotation")}</>)}</MyContext.Consumer>} onClick={(event) => { this.changeEncryptionKey(this.props.apol) }} />
                                        ) : (
                                            <DefaultButton text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "requestForRotation")}</>)}</MyContext.Consumer>} disabled />
                                        )}

                                        <br />
                                    </>}
                                </div>}

                                {/* Key creation interval */}
                                {this.state.rotationType == "Interval" && <div>
                                    <Label><MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyCreationInterval")}</>)}</MyContext.Consumer></Label>
                                    <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "every")}</>)}</MyContext.Consumer><br />
                                    <div style={{ diplay: "flex" }}>
                                        <TextField type="Number" className="displayKeyRotationSettings" name="RotationDays" min={1} defaultValue={this.state.intervalDays}
                                            onChange={(event) => { this.handleChange(event.target.value, 52) }}>
                                        </TextField>
                                        <Label className="displayKeyRotationSettings"><MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "days")}</>)}</MyContext.Consumer></Label>
                                    </div>

                                    {/* Delay of activation */}
                                    <Label><MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "delayOfActivation")}</>)}</MyContext.Consumer></Label>

                                    <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "for")}</>)}</MyContext.Consumer><br />
                                    <div style={{ diplay: "flex" }}>
                                        <TextField type="Number" className="displayKeyRotationSettings" name="ActivationDelayDay" min={0} value={this.state.activationDelay}
                                            onChange={(event) => { this.handleChange(event.target.value, 53) }}>
                                        </TextField>
                                        <Label className="displayKeyRotationSettings"><MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "days")}</>)}</MyContext.Consumer></Label>
                                    </div>

                                    <Label><MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyExpirationDate")}</>)}</MyContext.Consumer></Label>

                                    <Checkbox
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyExpiration")}</>)}</MyContext.Consumer>}
                                        checked={this.state.willExpire}
                                        onChange={(event, newValue) => { this.handleChange(newValue, 56) }}
                                        id="keyExpiration"
                                    />
                                    {this.state.keyExpirationMessage &&
                                        <TeachingBubble
                                            target={`#${"keyExpiration"}`}
                                            secondaryButtonProps={{ children: <MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "no")}</>)}</MyContext.Consumer>, onClick: () => { this.setState({ willExpire: false, keyExpirationMessage: false }) } }}
                                            primaryButtonProps={{ children: <MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "yes")}</>)}</MyContext.Consumer>, onClick: () => { this.setState({ willExpire: true, keyExpirationMessage: false }) } }}
                                            headline={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "warning")}</>)}</MyContext.Consumer>
                                            }

                                        >
                                            <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "keyExpirationCheckboxWarningMsg")}</>)}</MyContext.Consumer>

                                        </TeachingBubble>
                                    }
                                    {this.state.willExpire && <div>
                                        <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "after")}</>)}</MyContext.Consumer> < br />
                                        <div style={{ diplay: "flex" }}>
                                            <TextField type="number" id="expirationDaysField" className="displayKeyRotationSettings" min={1} name="ExpirationDays" defaultValue={(this.state.expireDays == 0 ? this.state.intervalDays : this.state.expireDays)}
                                                onChange={(event) => {
                                                    this.handleChange(event.target.value, 54);
                                                }}>
                                            </TextField>
                                            <Label className="displayKeyRotationSettings"><MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "days")}</>)}</MyContext.Consumer></Label>
                                        </div></div>}


                                    {this.state.willExpire && <Button id="keyExpirationBtn" text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("dashboard", "checkValidity")}</>)}</MyContext.Consumer>} onClick={(event) => { this.checkKeyExpirationValidity(this.props.apol) }} disabled={this.state.TTLLoading} />}
                                    {this.state.keyExpirationButtonMessage &&
                                        <TeachingBubble
                                            target={`#${"keyExpirationBtn"}`}
                                            secondaryButtonProps={{ children: <MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "no")}</>)}</MyContext.Consumer>, onClick: () => { this.setState({ keyExpirationButtonMessage: false, keyExpirationConfirmed: false }) } }}
                                            primaryButtonProps={{ children: <MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "yes")}</>)}</MyContext.Consumer>, onClick: () => { this.setState({ keyExpirationButtonMessage: false, keyExpirationConfirmed: true }) } }}
                                            headline={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "warning")}</>)}</MyContext.Consumer>
                                            }

                                        >
                                            <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "maxTtlFoundMsg") + (this.state.maxTtlFound + this.state.intervalDays) + "(Maximum TTL found + Interval days value)" + context.getTranslation("tenants", "keyExpirationButtonWarningMsg")}</>)}</MyContext.Consumer>

                                        </TeachingBubble>
                                    }
                                </div>}

                            </Stack.Item>}
                        <Stack.Item styles={this.styles}>
                            <Query
                                query={getTenantRegions}
                                variables={this.props.authorization} >
                                {({ loading, error, data }) => {
                                    if (loading) return <div>
                                        <Spinner label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "loadingRegions")}</>)}</MyContext.Consumer>} ariaLive="assertive" labelPosition="top" />
                                    </div>;
                                    if (error) return <h1> </h1>;

                                    if (data.getTenantRegions == null) {
                                        return <div></div>;
                                    }

                                    this.tmpKey = [];
                                    const license = data.getTenantRegions;
                                    if (data.getTenantRegions != null) {
                                        for (let x = 0; x < license.length; x++) {
                                            let i = {
                                                key: license[x],
                                                text: license[x],
                                            };
                                            this.tmpKey.push(i);
                                        }
                                    }


                                    return <ComboBox
                                        style={{ width: "300px" }}
                                        placeholder="Select an option"
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "processingRegion")}</>)}</MyContext.Consumer>}
                                        options={this.tmpKey}
                                        selectedKey={this.state.processingRegion}
                                        onChange={(ev, newVal) => {
                                            this.setState({
                                                processingRegion: newVal.key,
                                                isChanged: true
                                            });
                                        }}
                                        disabled={true}

                                    />
                                }
                                }

                            </Query>

                        </Stack.Item>
                        <br />
                        <br />
                        <hr />
                        <Stack.Item styles={this.styles}>
                            <Checkbox
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "eventHub")}</>)}</MyContext.Consumer>}
                                checked={this.state.eventHubVisible}
                                onChange={(event, newValue) => {
                                    this.handleChange(newValue, 93);
                                }}
                            />
                            {this.state.eventHubVisible &&
                                <>
                                    <TextField
                                        id="eventHubNamespace"
                                        value={this.state.eventHubNamespace}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "eventHubNamespace")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 94);
                                        }}
                                    />
                                    <span id="eventHubNamespaceError" style={{ color: "red" }}></span>
                                    <TextField
                                        id="eventHubName"
                                        value={this.state.eventHubName}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "eventHubName")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 95);
                                        }}
                                    />
                                    <span id="eventHubNameError" style={{ color: "red" }}></span>
                                    <br />
                                    <DefaultButton
                                        id="checkBtnEventHub"
                                        text={<MyContext.Consumer>{(context) => <> {context.getTranslation("dashboard", "checkValidity")}</>}</MyContext.Consumer>}
                                        onClick={(event) => { this.checkEventHubUrl(this.props.apol) }}
                                    />
                                </>}
                        </Stack.Item>
                        <br />
                        <br />
                        <hr />
                        <Stack.Item styles={this.styles}>
                            <Checkbox
                                label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafka")}</>)}</MyContext.Consumer>}
                                checked={this.state.kafkaVisible}
                                onChange={(event, newValue) => {
                                    this.handleChange(newValue, 105);
                                }}
                            />
                            {this.state.kafkaVisible &&
                                <>
                                    <TextField
                                        id="kafkaBootstrapServers"
                                        value={this.state.kafkaBootstrapServers}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaBootstrapServers")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 106);
                                        }}
                                    />
                                    <span id="kafkaBootstrapServersError" style={{ color: "red" }}></span>
                                    <TextField
                                        id="kafkaTopic"
                                        value={this.state.kafkaTopic}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaTopic")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 107);
                                        }}
                                    />
                                    <span id="kafkaTopicError" style={{ color: "red" }}></span>
                                    <TextField
                                        id="kafkaSecurityProtocol"
                                        value={this.state.kafkaSecurityProtocol}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSecurityProtocol")}</>)}</MyContext.Consumer>}
                                        placeholder="Ssl / SaslSsl"
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 108);
                                        }}
                                    />
                                    <Label>
                                        <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSslCaLocation")}</>)}</MyContext.Consumer>
                                        {this.isKafkaSecretConfigured(this.state.kafkaSslCaLocation) &&
                                            <i className="ms-Icon ms-Icon--Accept" style={{ fontSize: "16px", marginLeft: "8px", color: "green" }}></i>}
                                    </Label>
                                    <input
                                        type="file"
                                        id="kafkaSslCaLocation"
                                        accept=".pem,.cer,.crt,.cc,.ca"
                                        onChange={(event) => { this.onKafkaFileChange(event, 109); }}
                                    />
                                    <Label>
                                        <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSslCertificateLocation")}</>)}</MyContext.Consumer>
                                        {this.isKafkaSecretConfigured(this.state.kafkaSslCertificateLocation) &&
                                            <i className="ms-Icon ms-Icon--Accept" style={{ fontSize: "16px", marginLeft: "8px", color: "green" }}></i>}
                                    </Label>
                                    <input
                                        type="file"
                                        id="kafkaSslCertificateLocation"
                                        accept=".pem,.cer,.crt,.cc"
                                        onChange={(event) => { this.onKafkaFileChange(event, 110); }}
                                    />
                                    <Label>
                                        <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSslKeyLocation")}</>)}</MyContext.Consumer>
                                        {this.isKafkaSecretConfigured(this.state.kafkaSslKeyLocation) &&
                                            <i className="ms-Icon ms-Icon--Accept" style={{ fontSize: "16px", marginLeft: "8px", color: "green" }}></i>}
                                    </Label>
                                    <input
                                        type="file"
                                        id="kafkaSslKeyLocation"
                                        accept=".pem,.key,.cc"
                                        onChange={(event) => { this.onKafkaFileChange(event, 111); }}
                                    />
                                    <TextField
                                        id="kafkaSslKeyPassword"
                                        value={this.state.kafkaSslKeyPassword}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSslKeyPassword")}</>)}</MyContext.Consumer>}
                                        type="password"
                                        canRevealPassword
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 112);
                                        }}
                                    />
                                    <TextField
                                        id="kafkaSaslMechanism"
                                        value={this.state.kafkaSaslMechanism}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSaslMechanism")}</>)}</MyContext.Consumer>}
                                        placeholder="Plain"
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 113);
                                        }}
                                    />
                                    <TextField
                                        id="kafkaSaslUsername"
                                        value={this.state.kafkaSaslUsername}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSaslUsername")}</>)}</MyContext.Consumer>}
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 114);
                                        }}
                                    />
                                    <TextField
                                        id="kafkaSaslPassword"
                                        value={this.state.kafkaSaslPassword}
                                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "kafkaSaslPassword")}</>)}</MyContext.Consumer>}
                                        type="password"
                                        canRevealPassword
                                        onChange={(event) => {
                                            this.handleChange(event.target.value, 115);
                                        }}
                                    />
                                    <br />
                                    <DefaultButton
                                        id="checkBtnKafka"
                                        text={<MyContext.Consumer>{(context) => <> {context.getTranslation("dashboard", "checkValidity")}</>}</MyContext.Consumer>}
                                        onClick={(event) => { this.checkKafkaUrl(this.props.apol) }}
                                    />
                                </>}
                        </Stack.Item>
                        <br />
                        <br />
                        <hr />
                    </Stack>}

                    <br />

                    {/* AUDIO STORAGE SETTINGS*/}
                    <Stack.Item>

                        <Panel
                            type={PanelType.medium}
                            isOpen={this.state.showAudioStoragePanel}
                            hasCloseButton={true}
                            headerText={"Audio Storage Configuration"}
                            focusTrapZoneProps={{
                                isClickableOutsideFocusTrap: true,
                                forceFocusInsideTrap: false
                            }}
                            onDismiss={this._onDismissAudioStoragePanel}
                        >
                            {this.openAudioStorageSettings(
                                this.state.audioStorageOverride != null ? this.state.audioStorageOverride : (this.props.data != null ? this.props.data.audioStorage : null),
                                this.state.storage
                            )}
                        </Panel>

                        <Label onClick={this._onOpenAudioStoragePanel} style={{ "cursor": "pointer" }}>
                            <i className="ms-Icon ms-Icon--Audio"></i> <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "audioStorage")}</>)}</MyContext.Consumer>
                        </Label>


                    </Stack.Item>

                    <br />
                    {/*enable/disable suspension of all conversation deletion process*/}
                    <Checkbox
                        id={"suspendDeletion"}
                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "suspensionConvDeleteProcess")}</>)}</MyContext.Consumer>}
                        checked={this.state.tenantSuspensionConvDelProcess}
                        onChange={(event, newValue) => {
                            this.handleChange(newValue, 75);

                        }}
                        disabled={!this.props.userRules.ruleAccess.suspensionConvDelProcess}
                    />

                    {this.state.deletionNotifyMessage &&
                        <TeachingBubble
                            target={`#${"suspendDeletion"}`}
                            secondaryButtonProps={{ children: <MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "no")}</>)}</MyContext.Consumer>, onClick: () => { this.setState({ deletionNotifyMessage: false, tenantSuspensionConvDelProcess: !this.state.tenantSuspensionConvDelProcess }) } }}
                            primaryButtonProps={{ children: <MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "yes")}</>)}</MyContext.Consumer>, onClick: () => { this.setState({ deletionNotifyMessage: false }) } }}
                            headline={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "warning")}</>)}</MyContext.Consumer>
                            }
                        >

                            {this.state.tenantSuspensionConvDelProcess
                                ? <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "suspensionMsgDeletionWarningCheck")}</>)}</MyContext.Consumer>

                                : <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "suspensionMsgDeletionWarningUncheck")}</>)}</MyContext.Consumer>
                            }
                        </TeachingBubble>
                    }
                    <br />
                    {/*enable Chat Model A*/}
                    <Checkbox
                        id={"enableChatModelA"}
                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "chatModelA")}</>)}</MyContext.Consumer>}
                        checked={this.state.chatModelA}
                        onChange={(event, newValue) => {
                            this.handleChange(newValue, 86);

                        }}
                        disabled={this.state.addOnFullChat == 0}
                    />
                    {/* Bot Onboarding */}
                    <Stack.Item>

                        <Panel
                            type={PanelType.medium}
                            isOpen={this.state.showBotOnboardingPanel}
                            hasCloseButton={true}
                            headerText={"Bot Onboarding"}
                            focusTrapZoneProps={{
                                isClickableOutsideFocusTrap: true,
                                forceFocusInsideTrap: false
                            }}
                            onDismiss={this._onDismissBotOnboardingPanel}
                        >
                            {this.openBotOnboardingSettings(this.props.data != null ? this.props.data.botOnboarding : null)}
                        </Panel>

                        <Label onClick={this._onOpenBotOnboardingPanel} style={{ "cursor": "pointer" }}>
                            <i className="ms-Icon ms-Icon--Bot"></i> <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "botOnboarding")}</>)}</MyContext.Consumer>
                        </Label>


                    </Stack.Item>

                </Stack>
            </Stack.Item>


            {this.props.userRules.access != "Order" &&
                <Stack>
                    <Stack.Item styles={this.styles}>
                        <Checkbox
                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "bulkUserImport")}</>)}</MyContext.Consumer>}
                            value={this.state.bulkImport}
                            onChange={(event, newValue) => {
                                this.setState({
                                    bulkImport: newValue
                                });
                            }}
                        />
                    </Stack.Item>
                    {this.state.bulkImport &&
                        <ApolloProvider client={this.props.apol}>
                            {this.query(this.props.authorization)}

                        </ApolloProvider>
                    }

                    {this.props.userRules.ruleAccess.tenantCreate && <Stack>
                        <Stack.Item styles={this.styles}>
                            <Checkbox
                                label="Delete all metadata of a Tenant"
                                value={this.state.deleteTenantMetadata}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        deleteTenantMetadata: newValue
                                    });
                                }}
                            />
                        </Stack.Item>
                        {this.state.deleteTenantMetadata && <Stack>
                            <Stack.Item styles={this.styles}>
                                <div>End Date</div>
                                <DatePicker
                                    onSelectDate={(date) => {
                                        this.setState({ deleteTenantMetadataDate: date })
                                    }}
                                    value={this.state.deleteTenantMetadataDate}
                                />
                                <TextField min={0} value={this.state.deletePassword} type="Number" label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "password")}</>)}</MyContext.Consumer>}
                                    onChange={(event) => { this.setState({ deletePassword: event.target.value }) }}
                                />
                            </Stack.Item>
                            <Stack.Item styles={this.styles}>
                                <PrimaryButton
                                    onClick={(event) => { this.deleteTenantMetadata(this.props.apol) }}
                                    text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "startDeleteTenantMetadata")}</>)}</MyContext.Consumer>} />
                            </Stack.Item>
                            <Stack.Item styles={this.styles}>
                                <Text style={{ color: this.state.deleteTenantMetadataStatus === "success" ? "green" : this.state.deleteTenantMetadataStatus === "error" ? "red" : undefined }}>
                                    {this.state.deleteTenantMetadataText}
                                </Text>
                            </Stack.Item>
                        </Stack>}
                    </Stack>}
                    {this.props.userRules.ruleAccess.tenantCreate && <Stack>
                        <Stack.Item styles={this.styles}>
                            <Checkbox
                                label="Delete Tenant with all related items and recordings"
                                value={this.state.deleteTenant}
                                onChange={(event, newValue) => {
                                    this.setState({
                                        deleteTenant: newValue
                                    });
                                }}
                            />
                        </Stack.Item>
                        {this.state.deleteTenant && <>

                            {(this.state.checkTenantForDelete !== true) && (
                                <Stack.Item styles={this.styles}>
                                    <PrimaryButton
                                        text="Check Tenant Metadata For Deletion"
                                        onClick={() => this.checkTenantMetadataForDeletion(this.props.apol)}
                                    />
                                </Stack.Item>
                            )}

                            {this.state.checkTenantForDelete === true && (
                                <Stack>
                                    <Stack.Item styles={this.styles}>
                                        <TextField
                                            min={0}
                                            value={this.state.deletePassword}
                                            type="Number"
                                            label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "password")}</>)}</MyContext.Consumer>}
                                            onChange={(event) => { this.setState({ deletePassword: event.target.value }) }}
                                        />
                                    </Stack.Item>
                                    <Stack.Item styles={this.styles}>
                                        <PrimaryButton
                                            onClick={(event) => { this.deleteTenant(this.props.apol) }}
                                            text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "startDeleteTenant")}</>)}</MyContext.Consumer>}
                                        />
                                    </Stack.Item>
                                    <Stack.Item styles={this.styles}>
                                        <Text>{this.state.deleteTenantText}</Text>
                                    </Stack.Item>
                                </Stack>
                            )}

                            {this.state.checkTenantForDelete === false && (
                                <Stack.Item styles={this.styles}>
                                    <Text style={{ color: "red" }}>{this.state.checkTenantForDeleteError}</Text>
                                </Stack.Item>
                            )}
                        </>}
                    </Stack>}
                    <Stack>
                        <Stack.Item styles={this.styles}>
                            <Checkbox
                                id="checkboxAILogging"
                                label="AI Service - Interaction logging"
                                defaultChecked={this.state.checkboxAILogging}
                                checked={this.state.checkboxAILogging}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        this.setState({
                                            checkboxAILogging: newValue,
                                            interactionTeachingBubble: newValue
                                        });
                                    } else if (!newValue) {
                                        this.handleChange(newValue, 90)
                                        this.setState({ interactionTeachingBubble: newValue })
                                    }
                                }}
                            />
                        </Stack.Item>
                        {this.state.interactionTeachingBubble && <TeachingBubble
                            target={`#${"checkboxAILogging"}`}
                            secondaryButtonProps={{
                                children: this.context.getTranslation("common", "cancel"),
                                onClick: () => {
                                    this.setState({ checkboxAILogging: false, interactionTeachingBubble: false, interactionLogging: false })
                                }
                            }}
                            primaryButtonProps={{
                                children: this.context.getTranslation("compliance", "confirmAction"),
                                onClick: () => {
                                    console.log("ischanged " + this.state.isChanged)
                                    this.handleChange(true, 90)
                                    this.setState({ interactionTeachingBubble: false })
                                }
                            }}
                        >
                            {this.context.getTranslation("tenants", "aILoggingConfirmation")}
                        </TeachingBubble>}
                        {this.state.interactionLogging &&
                            <Stack.Item styles={this.styles}>
                                <UserPicker
                                    //id="assignedTo"
                                    //disabled={this.grantObject.assignedTo.disabled}
                                    placeholder={this.context.getTranslation("compliance", "selectUserOrGroup")}
                                    user={this.state.allowedUsers.map(user => {
                                        return ({ "userId": user })
                                    })}
                                    fc={(user) => { this.handleChange(user, 91) }}
                                />
                                <div>Start Date</div>
                                <DateTimePicker
                                    calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}
                                    onChange={(date) => {
                                        if ((this.state.loggingStartDate === '' || this.state.loggingStartDate == null) &&
                                            (this.state.loggingStopDate === '' || this.state.loggingStopDate == null) ||
                                            (this.state.loggingStartDate !== '' || this.state.loggingStartDate != null) &&
                                            (this.state.loggingStopDate === '' || this.state.loggingStopDate == null)
                                        ) {
                                            this.handleChange(date, 88)
                                        } else if (date <= this.state.loggingStopDate) {
                                            this.handleChange(date, 88)
                                        }
                                    }}
                                    value={this.state.loggingStartDate}
                                />
                                <div>End Date</div>
                                <DateTimePicker
                                    calendarClassName={this.props.theme.palette.black < "#100000" ? "Light" : "Dark"}
                                    onChange={(date) => {
                                        if ((this.state.loggingStartDate === '' || this.state.loggingStartDate == null) &&
                                            (this.state.loggingStopDate === '' || this.state.loggingStopDate == null) ||
                                            (this.state.loggingStopDate !== '' || this.state.loggingStopDate != null) &&
                                            (this.state.loggingStopDate === '' || this.state.loggingStopDate == null)
                                        ) {
                                            this.handleChange(date, 89)
                                        } else if (date >= this.state.loggingStartDate) {
                                            this.handleChange(date, 89)
                                        }
                                    }}
                                    value={this.state.loggingStopDate}
                                />
                            </Stack.Item>
                        }
                    </Stack>

                </Stack>}
            <Stack.Item styles={this.styles}>
                {this.state.error.adminId === "adminIdAlreadyExists" && (
                    <MessageBar
                        messageBarType={MessageBarType.error}
                        isMultiline={false}
                        styles={{ root: { marginBottom: 16 } }}
                    >
                        <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "adminIdAlreadyExists")}</>)}</MyContext.Consumer>
                    </MessageBar>
                )}
                <Stack horizontal>
                    <Stack.Item>
                        <DefaultButton onClick={(event) => { this.props.cl() }} text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "cancel")}</>)}</MyContext.Consumer>} />
                    </Stack.Item>
                    <Stack.Item>
                        <PrimaryButton
                            id="saveBtn"
                            onClick={(event) => { this.notifyTenantChange(this.props.apol) }}
                            text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("common", "save")}</>)}</MyContext.Consumer>}
                            disabled={this.saveDisableCheck() || this.state.isSaving} />
                    </Stack.Item>
                    {this.state.createSubUnit && (
                        <TeachingBubble
                            target="#saveBtn"
                            headline="Tenant with the same TenantId already exists."
                            primaryButtonProps={{
                                children: "Yes",
                                onClick: () => {
                                    this.setState({ createSubUnit: true }, () => {
                                        this.notifyTenantChange(this.props.apol);
                                    });
                                }
                            }}
                            secondaryButtonProps={{
                                children: "No",
                                onClick: () => {
                                    this.setState({ createSubUnit: false });
                                }
                            }}
                        >
                            Do you want to create a new one?
                        </TeachingBubble>
                    )}
                </Stack>
            </Stack.Item>
        </Stack>
        );
    }

    query = (auth) => {
        return (<Query
            query={queryGetRuleData}
            variables={{ auth }}>
            {({ loading, error, data }) => {
                if (loading) return <div>
                    <Spinner label="Loading Rules ..." ariaLive="assertive" labelPosition="top" />
                </div>;
                if (error) return <h1> </h1>;

                if (data.getRuleData == null) {
                    return <div> </div>;
                }
                return <Stack><Stack.Item styles={this.styles}>
                    <ComboBox
                        style={{ width: "300px" }}
                        placeholder="Select an option"
                        label={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "exportCycle")}</>)}</MyContext.Consumer>}
                        options={[{
                            key: "1",
                            text: "Compliance UC License"
                        },
                        {
                            key: "2",
                            text: "Compliance&Analytics UC License",
                        },
                        {
                            key: "3",
                            text: "Smart UC License",
                        },
                        {
                            key: "4",
                            text: "Smart&Analytics UC License",
                        },
                        {
                            key: "5",
                            text: "Chat Recording Standalone License"
                        },
                        {
                            key: "6",
                            text: "Compliance Voice License"
                        },
                        {
                            key: "7",
                            text: "Compliance Voice & Analytics License"
                        },
                        {
                            key: "8",
                            text: "Smart Voice License"
                        },
                        {
                            key: "9",
                            text: "Smart Voice & Analytics License"
                        }]
                        }
                        selectedKey={this.state.bulkLicense}
                        onChange={(event, option, index, newValue) => { this.setState({ bulkLicense: option.key }) }}
                    />
                </Stack.Item>
                    <Stack.Item styles={this.styles}>
                        <Dropdown placeholder="Select an option" label="Recording" selectedKey={this.state.bulkRuleRecording} onChange={(event, newValue) => { this.setState({ bulkRuleRecording: newValue.key }) }} options={recordingOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                        <Dropdown placeholder="Select an option" label="Replay" selectedKey={this.state.bulkRuleReplay} onChange={(event, newValue) => { this.setState({ bulkRuleReplay: newValue.key }) }} options={replayOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                        <Dropdown placeholder="Select an option" label="Access" selectedKey={this.state.bulkRuleAccess} onChange={(event, newValue) => { this.setState({ bulkRuleAccess: newValue.key }) }} options={accessOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                        <Dropdown placeholder="Select an option" label="Analytics" selectedKey={this.state.bulkRuleAnalytics} onChange={(event, newValue) => { this.setState({ bulkRuleAnalytics: newValue.key }) }} options={analyticsOption(data.getRuleData.ruledata)} styles={dropdownStyles} />
                    </Stack.Item>
                    <Stack.Item>
                        <TextField label={"User List"}
                            onChange={(event) => { this.setState({ bulkUserList: event.target.value }) }}
                            value={this.state.bulkUserList}
                        />
                    </Stack.Item>
                    <Stack.Item styles={this.styles}>
                        <PrimaryButton
                            onClick={(event) => { this.bulkImport(this.props.apol); }}
                            text={<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "import")}</>)}</MyContext.Consumer>} disabled={this.state.bulkUserList == "" || this.state.bulkLicense == ""} />
                    </Stack.Item>
                    <Stack.Item styles={this.styles}>
                        <Text>{this.state.bulkImportText}</Text>
                    </Stack.Item>
                </Stack>

            }}
        </Query>);
    };

    handleChange(text, id) {
        const numberFieldIds = [3, 4, 10, 11, 12, 14, 15, 16, 18, 19, 57, 58, 59, 60, 61, 62, 63, 68, 69, 70, 71, 72, 73, 74, 76, 83, 84, 96, 97, 99, 100, 101, 103, 104];
        if (numberFieldIds.includes(id) && text !== '' && text !== undefined && text !== null && typeof text === 'string' && text.includes('-')) {
            text = '0';
        }
        switch (id) {
            case 0: this.setState({ name: text }); break;
            case 1: this.setState({ tenantId: text }); break;
            case 2: this.setState({ adminId: text }); break;
            case 3: this.setState({ license1: text }); break;
            case 4: this.setState({ license2: text }); break;
            case 5: if (text === "S3") {
                this.setState({
                    storage: text,
                    asymmetricKeyEnabled: false
                });
            } else {
                this.setState({
                    storage: text,
                })
            } break;
            case 6: this.setState({ exportType: text }); break;
            case 7: this.setState({ exportStorage: text }); break;
            case 10: this.setState({ license3: text }); break;
            case 11: this.setState({ license4: text }); break;
            case 12: this.setState({ license5: text }); break;
            case 13: this.setState({ type: text }); break;
            case 14: this.setState({ packageStorage: text }); break;
            case 15: this.setState({ packageAnalyticsVideo: text }); break;
            case 16: this.setState({ packageExport: parseInt(text) }); break;
            case 17: this.setState({ mailAlarming: text }); break;
            case 18: this.setState({ packageAnalyticsSpeech: text }); break;
            case 19: this.setState({ packageAnalyticsTranslate: text }); break;
            case 20: this.setState({ contractNumber: text }); break;
            case 21: this.setState({ customStorage: text }); break;
            case 22: this.setState({ country: text }); break;
            case 23: this.setState({ onboardingDate: text }); break;
            case 24: this.setState({ billingDate: text }); break;
            case 25: this.setState({ partner: text }); break;
            case 26: this.setState({ partnerContract: text }); break;
            case 27: this.setState({ support: text }); break;
            case 28: this.setState({ bot01: text }); break;
            case 29: break;
            case 48: this.setState({ keyManagementType: text }); break;
            case 49: this.setState({ keySecurity: text }); break;
            case 50: this.setState({ customEncryptionKeyVaultUrl: text }); break;
            case 51: this.setState({ customEncryptionKeySecretName: text }); break;
            case 52: this.setState({ intervalDays: text == 0 ? 1 : parseInt(text) }); break;
            case 53: this.setState({ activationDelay: text }); break;
            case 54: this.setState({ expireDays: parseInt(text), keyExpirationConfirmed: false }); break;
            case 55: this.setState({ rotationType: text }); break;
            case 56: this.setState({ willExpire: text, keyExpirationMessage: text }); break;
            case 57: this.setState({ license6: text }); break;
            case 58: this.setState({ license7: text }); break;
            case 59: this.setState({ packageAnalyticsTranscript: text }); break;
            case 60: this.setState({ license8: text }); break;
            case 61: this.setState({ license9: text }); break;
            case 62: this.setState({ addOnAnalytics: text }); break;
            case 63: this.setState({ addOnFullChat: text }); break;

            case 64: this.setState({ domainRestrictionsList: text }); break;
            case 65: this.setState({ trainingDate: text }); break;
            case 66: this.setState({ supportNotes: text }); break;
            case 67: this.setState({ systemId: text }); break;
            case 68: this.setState({ addOnZoom: text }); break;
            case 69: this.setState({ addOnGenesys: text }); break;
            case 70: this.setState({ addOnRingcentral: text }); break;
            case 71: this.setState({ addOnDynamics: text }); break;
            case 72: this.setState({ addOnCompliance: text }); break;
            case 73: this.setState({ packageImport: parseInt(text) }); break;
            case 74: this.setState({ packageArchive: parseInt(text) }); break;
            case 75: this.setState({ tenantSuspensionConvDelProcess: text, deletionNotifyMessage: true }); break;
            case 76: this.setState({ packageAnalyticsAI: text }); break;
            case 77: this.setState({ awsAccessKeyId: text, s3Check: "false" }); break;
            case 78: this.setState({ awsSecretAccess: text, s3Check: "false" }); break;
            case 79: this.setState({ awsBucketName: text, s3Check: "false" }); break;
            case 80: this.setState({ asymmetricKeyEnabled: text, rotationType: "No" }); break;
            case 81: this.setState({ keyType: text }); break;
            case 82: this.setState({ keySetting: text }); break;
            case 83: this.setState({ addOnLeapXpert: text }); break;
            case 84: this.setState({ license10: text }); break;
            case 85: this.setState({ addOnQualityManagement: text }); break;
            case 86: this.setState({ chatModelA: text }); break;
            case 87: break;
            case 88: this.setState({ loggingStartDate: text }); break;
            case 89: this.setState({ loggingStopDate: text }); break;
            case 90: this.setState({ checkboxAILogging: text, interactionLogging: text }); break;
            case 91: this.setState({ allowedUsers: text.map(u => u.userId) }); break;
            case 92: this.setState({ hsm: text, rotationType: "No" }); break;
            case 93: this.setState({ eventHubVisible: text, eventHubNamespace: text ? this.state.eventHubNamespace : "", eventHubName: text ? this.state.eventHubName : "", validateEventHubUrl: "false" }); break;
            case 94: this.setState({ eventHubNamespace: text }); break;
            case 95: this.setState({ eventHubName: text }); break;
            case 96: this.setState({ packageAnalyticsBatchTranscript: text }); break;
            case 97: this.setState({ license11: text }); break;
            case 99: this.setState({ license12: text }); break;
            case 100: this.setState({ addOnMsftTeamsVoice: text }); break;
            case 101: this.setState({ addOnMsftTeamsUC: text }); break;
            case 102: this.setState({ commercialContactMail: text }); break;
            case 103: this.setState({ license13: text }); break;
            case 104: this.setState({ addOnEmail: text }); break;
            case 105: this.setState({ kafkaVisible: text, kafkaBootstrapServers: text ? this.state.kafkaBootstrapServers : "", kafkaTopic: text ? this.state.kafkaTopic : "", kafkaSecurityProtocol: text ? this.state.kafkaSecurityProtocol : "", kafkaSslCaLocation: text ? this.state.kafkaSslCaLocation : "", kafkaSslCertificateLocation: text ? this.state.kafkaSslCertificateLocation : "", kafkaSslKeyLocation: text ? this.state.kafkaSslKeyLocation : "", kafkaSslKeyPassword: text ? this.state.kafkaSslKeyPassword : "", kafkaSaslMechanism: text ? this.state.kafkaSaslMechanism : "", kafkaSaslUsername: text ? this.state.kafkaSaslUsername : "", kafkaSaslPassword: text ? this.state.kafkaSaslPassword : "", validateKafkaUrl: "false" }); break;
            case 106: this.setState({ kafkaBootstrapServers: text }); break;
            case 107: this.setState({ kafkaTopic: text }); break;
            case 108: this.setState({ kafkaSecurityProtocol: text }); break;
            case 109: this.setState({ kafkaSslCaLocation: text }); break;
            case 110: this.setState({ kafkaSslCertificateLocation: text }); break;
            case 111: this.setState({ kafkaSslKeyLocation: text }); break;
            case 112: this.setState({ kafkaSslKeyPassword: text }); break;
            case 113: this.setState({ kafkaSaslMechanism: text }); break;
            case 114: this.setState({ kafkaSaslUsername: text }); break;
            case 115: this.setState({ kafkaSaslPassword: text }); break;
            case 116: this.setState({ showTicketPage: text }); break;
            case 117: this.setState({ addOnAIEntry: text }); break;
            case 118: this.setState({ addOnN1Mapping: text }); break;
            case 'addOnWebex': this.setState({ addOnWebex: text }); break;
            case 119: this.setState({ addOnRealTimeTranscript: text }); break;
            case 'addOnCloud9': this.setState({ addOnCloud9: text }); break;
            case 120: this.setState({ analyticsSpeechCapacity: text }); break;
            case 121: this.setState({ analyticsTranscriptCapacity: text }); break;
            case 122: this.setState({ analyticsBatchTranscriptCapacity: text }); break;
            case 123: this.setState({ analyticsVideoCapacity: text }); break;
            case 124: this.setState({ analyticsTranslateCapacity: text }); break;
            case 125: this.setState({ analyticsAICapacity: text }); break;
            default: break;

        }
        // Decide to set isChanged
        // Tenant ID / Admin ID are disabled and immutable once a tenant exists, so their format
        // is only enforced here when creating a new tenant (matches validateFields()); otherwise
        // legacy tenants whose IDs predate the UUID requirement could never be saved again.
        if ((this.props.data || /^[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}$/.test(id === 1 ? text : this.state.tenantId))
            && (this.props.data || /^[0-9A-Fa-f]{8}(?:-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}$/.test(id === 2 ? text : this.state.adminId))
            && (this.state.storage !== "Own")
            && (id === 0 ? text : this.state.name) !== ""
            && (id === 5 ? text : this.state.storage) !== "Unknown"
            && ((id === 3 ? text : this.state.license1) !== 0
                || (id === 4 ? text : this.state.license2) !== 0
                || (id === 10 ? text : this.state.license3) !== 0
                || (id === 11 ? text : this.state.license4) !== 0
                || (id === 12 ? text : this.state.license5) !== 0
                || (id === 57 ? text : this.state.license6) !== 0
                || (id === 58 ? text : this.state.license7) !== 0
                || (id === 60 ? text : this.state.license8) !== 0
                || (id === 61 ? text : this.state.license9) !== 0
                || (id === 84 ? text : this.state.license10) !== 0
                || (id === 97 ? text : this.state.license11) !== 0
                || (id === 99 ? text : this.state.license12) !== 0
                || (id === 103 ? text : this.state.license13) !== 0
                || (id === 100 ? text : this.state.addOnMsftTeamsVoice) !== 0
                || (id === 101 ? text : this.state.addOnMsftTeamsUC) !== 0
            )
            && (id === 13 ? text : this.state.type !== "Unknown")
        ) {
            var changed = "";
            if ((id === 48 && text == "CustomKey") || this.state.keyManagementType == "CustomKey") {


                if (
                    this.props.data?.keyManagementType === "CustomKey" &&
                    this.props.data.keyManagement?.customEncryptionKeySecretName === this.state.customEncryptionKeySecretName &&
                    this.props.data.keyManagement?.customEncryptionKeyVaultUrl === this.state.customEncryptionKeyVaultUrl &&
                    this.state.validateKeyVault !== "false"
                ) {
                    this.setState({ validateKeyVault: "true" });
                    changed = "true";
                }
                if (id === 50 || id === 51 || this.state.validateKeyVault == "false") {
                    this.setState({ validateKeyVault: "false" });
                    changed = "false"
                }
                if (this.state.customEncryptionKeyVaultUrl == "" || this.state.customEncryptionKeySecretName == "") {
                    this.setState({ validateKeyVault: "false" });
                    changed = "false"
                }

                if (changed != "true" && changed != "") {
                    this.setState({ isChanged: false });

                } else {
                    this.setState({ isChanged: true });
                }



            } else {
                this.setState({ isChanged: true });

            }
            // Event Hub URL change check
            if (id === 93 || id === 94 || id === 95) {
                if (id === 93 && text === false) {
                    this.setState({
                        isChanged: true
                    });
                }
                else if ((id === 93 && text === true) || this.state.eventHubVisible === true) {
                    this.setState({
                        isChanged: false
                    });
                    if (id === 94 || id === 95 || this.state.validateEventHubUrl === "false") {
                        this.setState({
                            validateEventHubUrl: "false",
                            isChanged: false
                        });
                    }
                    else if (this.state.validateEventHubUrl === "true") {
                        this.setState({
                            isChanged: true
                        });
                    }
                }
            }
            // Kafka URL change check
            if (id === 105 || id === 106 || id === 107) {
                if (id === 105 && text === false) {
                    this.setState({
                        isChanged: true
                    });
                }
                else if ((id === 105 && text === true) || this.state.kafkaVisible === true) {
                    this.setState({
                        isChanged: false
                    });
                    if (id === 106 || id === 107 || this.state.validateKafkaUrl === "false") {
                        this.setState({
                            validateKafkaUrl: "false",
                            isChanged: false
                        });
                    }
                    else if (this.state.validateKafkaUrl === "true") {
                        this.setState({
                            isChanged: true
                        });
                    }
                }
            }
        } else {
            this.setState({ isChanged: false });
        }


        setTimeout(() => {
            const error = this.validateFields();
            this.setState({ error });
        }, 0);
    }

    bulkImport = async (apol) => {
        this.setState({ bulkImportText: "Import running ..." });
        var listUser = this.state.bulkUserList.split(";");
        var sendUserList = [];
        listUser.forEach((aUser) => {
            sendUserList.push({
                userId: aUser,
                license: this.state.bulkLicense,
                access: this.state.bulkRuleAccess,
                recordingRules: this.state.bulkRuleRecording,
                replay: this.state.bulkRuleReplay,
                analytics: this.state.bulkRuleAnalytics,
            });
        });
        var data = await apol
            .mutate({
                mutation: mutationBulkImport,
                variables: {
                    auth: this.props.authorization,
                    user: sendUserList,
                    tenantId: this.props.data.tenantId
                }
            });
        this.setState({ bulkImport: false, bulkImportText: "" });
    }

    groupSync = async (apol) => {
        var data = await apol
            .mutate({
                mutation: userGroupSync,
                variables: {
                    auth: this.props.authorization,
                    tenantId: this.props.data.tenantId
                }
            });

    }

    changeEncryptionKey = async (apol) => {
        var data = await apol
            .mutate({
                mutation: changeEncryptionKey
            });
        if (data) {
            document.getElementById("requestRotation").innerHTML = "Key Rotation Successful";
            document.getElementById("requestRotation").disabled = true;
            this.setState({ isChecked: false })

        } else {
            document.getElementById("requestRotation").innerHTML = "Key Rotation Unsuccessful";
            document.getElementById("requestRotation").disabled = true;
            this.setState({ isChecked: false })

        }
    }

    createCustomKeySecret = async (apol) => {
        var data = await apol
            .mutate({
                mutation: createCustomKeySecret,
                variables: {
                    customKeyVaultUrl: this.state.customEncryptionKeyVaultUrl,
                    customSecretName: this.state.customEncryptionKeySecretName
                }
            });

        if (data.data.createCustomKeySecret == true) {
            this.setState({ validateKeyVault: "true" });
            document.getElementById("secretName").style.border = "2px solid green";
            toast.success("Key name was created successfully", { autoClose: 5000, position: "bottom-left" });
            document.querySelector('#checkBtn').style.border = "2px solid green";
            document.getElementById("secretError").innerHTML = "";
            this.handleChange("", 73);


        } else {
            toast.error("Failed to create secret", { autoClose: 5000, position: "bottom-left" });
            document.getElementById("secretError").innerHTML = "Invalid secret name or SET right is missing. Secret names can only contain alphanumeric characters and dashes.";
            this.handleChange("", 73);

        }
    }

    checkCustomKeyVault = async (apol) => {
        var data = await apol
            .mutate({
                mutation: checkCustomKeyVault,
                variables: {
                    customKeyVaultUrl: this.state.customEncryptionKeyVaultUrl,
                    customSecretName: this.state.customEncryptionKeySecretName,
                    isAsymmetric: this.state.asymmetricKeyEnabled
                }
            });
        switch (data.data.checkCustomKeyVault) {
            case 0: //accessible
                document.getElementById("keyVault").style.border = "2px solid green";
                document.getElementById("secretName").style.border = "2px solid green";
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("secretError").innerHTML = "";
                toast.success("Key Vault and secret name are correct", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid green";
                this.setState({ validateKeyVault: "true" });
                break;
            case 1: //InvalidKeyVaultUrl
                document.getElementById("keyVaultError").innerHTML = "Key vault doesn't exist or permissions are not set";
                document.getElementById("keyVault").style.border = "2px solid red";
                toast.error("Key vault doesn't exist or permissions are not set", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 2://SecretNotFound
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "2px solid green";
                document.getElementById("secretError").innerHTML = "No key name was found";
                document.getElementById("secretName").style.border = "2px solid red";
                toast.error("No key name was found", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false", showModal: "true" });

                break;
            case 3://NoValidSecretVersion
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "2px solid green";
                document.getElementById("secretError").innerHTML = "No valid version of the secret was found (secret has to be enabled, active and not expired)";
                document.getElementById("secretName").style.border = "2px solid red";
                toast.error("No valid version of the secret was found (secret has to be enabled, active and not expired)", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 4://IncorrectSecretContentType
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "2px solid green";
                document.getElementById("secretError").innerHTML = "The content type of the secret is not correct, set the content type to 'application / octet - stream'";
                document.getElementById("secretName").style.border = "2px solid red";
                toast.error("The content type of the secret is not correct, set the content type to 'application / octet - stream'", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 5://IncorrectKeySize
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("keyVault").style.border = "2px solid green";
                document.getElementById("secretError").innerHTML = "The size of the key is invalid (valid sizes are 128, 192 or 256 bits)";
                document.getElementById("secretName").style.border = "2px solid red";
                toast.error("The size of the key is invalid (valid sizes are 128, 192 or 256 bits)", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 6: //ForbiddenOperation
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("secretError").innerHTML = "";
                document.getElementById("secretName").style.border = "";
                document.getElementById("keyVault").style.border = "";
                toast.error("Access Denied", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 7: //UnknownError
                document.getElementById("keyVaultError").innerHTML = "";
                document.getElementById("secretError").innerHTML = "";
                document.getElementById("secretName").style.border = "";
                document.getElementById("keyVault").style.border = "";
                toast.error("Unknown Error", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false" });

                break;
            case 8: //InvalidKeyContentEncoding
                document.getElementById("keyVaultError").innerHTML = "Invalid encoding for the key content";
                document.getElementById("keyVault").style.border = "2px solid red";
                toast.error("Invalid encoding for the key content", { autoClose: 5000, position: "top-left" });
                document.querySelector('#checkBtn').style.border = "2px solid red";
                this.setState({ validateKeyVault: "false" });

                break;


        }
        this.handleChange();

    }
    checkEventHubUrl = async (apol) => {
        var data = await apol
            .mutate({
                mutation: checkEventHubUrlValidity,
                variables: {
                    eventHubNamespace: this.state.eventHubNamespace,
                    eventHubName: this.state.eventHubName,
                }
            });

        switch (data.data.checkEventHubUrlValidity) {
            case "ForbiddenOperation":
                document.getElementById("eventHubNamespaceError").innerHTML = "";
                document.getElementById("eventHubNamespace").style.border = "";
                document.getElementById("eventHubNameError").innerHTML = "";
                document.getElementById("eventHubName").style.border = "";
                toast.error("Access Denied", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnEventHub').style.border = "2px solid red";
                this.setState({ validateEventHubUrl: "false" });
                break;
            case "InvalidNamespace":
                document.getElementById("eventHubNamespaceError").innerHTML = "Error: Host name is not valid";
                document.getElementById("eventHubNamespace").style.border = "2px solid red";
                document.getElementById("eventHubNameError").innerHTML = "";
                document.getElementById("eventHubName").style.border = "";
                toast.error("Invalid host name", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnEventHub').style.border = "2px solid red";
                this.setState({ validateEventHubUrl: "false" });
                break;
            case "InvalidHubName":
                document.getElementById("eventHubNamespaceError").innerHTML = "";
                document.getElementById("eventHubNamespace").style.border = "";
                document.getElementById("eventHubNameError").innerHTML = "Error: Event hub name is not valid";
                document.getElementById("eventHubName").style.border = "2px solid red";
                toast.error("Invalid event hub name", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnEventHub').style.border = "2px solid red";
                this.setState({ validateEventHubUrl: "false" });
                break;
            case "MissingRights":
                document.getElementById("eventHubNamespaceError").innerHTML = "";
                document.getElementById("eventHubNamespace").style.border = "";
                document.getElementById("eventHubNameError").innerHTML = "";
                document.getElementById("eventHubName").style.border = "";
                toast.error("Missing Rights", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnEventHub').style.border = "2px solid red";
                this.setState({ validateEventHubUrl: "false" });
                break;
            case "UnknownError":
                document.getElementById("eventHubNamespaceError").innerHTML = "";
                document.getElementById("eventHubNamespace").style.border = "";
                document.getElementById("eventHubNameError").innerHTML = "";
                document.getElementById("eventHubName").style.border = "";
                toast.error("Unknown Error", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnEventHub').style.border = "2px solid red";
                this.setState({ validateEventHubUrl: "false" });
                break;
            case "Valid":
                document.getElementById("eventHubNamespaceError").innerHTML = "";
                document.getElementById("eventHubNamespace").style.border = "2px solid green";
                document.getElementById("eventHubNameError").innerHTML = "";
                document.getElementById("eventHubName").style.border = "2px solid green";
                toast.success("Event hub URL is correct", { autoClose: 5000, position: "bottom-left" })
                document.querySelector('#checkBtnEventHub').style.border = "2px solid green";
                this.setState({ validateEventHubUrl: "true" });
                break;
        }

        this.handleChange();
    }

    // Reads an uploaded Kafka certificate / key file from the customer's client PC and stores its
    // text content in state. The content is sent to the backend, which stores it in the Azure Key
    // Vault - the files are never written to a server filesystem. id 109 = CA cert, 110 = client
    // cert, 111 = private key (see handleChange).
    onKafkaFileChange = async (event, id) => {
        let activeFile = event.target.files && event.target.files[0];
        if (!activeFile) {
            return;
        }
        let text = await activeFile.text();
        this.handleChange(text, id);
    };

    // A configured-but-unchanged secret is represented by this placeholder (the backend never sends
    // the real secret back). Matches KafkaCertificateStore.ConfiguredPlaceholder in the backend.
    isKafkaSecretConfigured = (value) => {
        // Non-empty state means either freshly uploaded content or the "already configured"
        // placeholder returned by the backend - both should show as configured.
        return !!value && value.length > 0;
    };

    checkKafkaUrl = async (apol) => {
        var data = await apol
            .mutate({
                mutation: checkKafkaUrlValidity,
                variables: {
                    kafkaBootstrapServers: this.state.kafkaBootstrapServers,
                    kafkaTopic: this.state.kafkaTopic,
                    kafkaSecurityProtocol: this.state.kafkaSecurityProtocol,
                    kafkaSslCaLocation: this.state.kafkaSslCaLocation,
                    kafkaSslCertificateLocation: this.state.kafkaSslCertificateLocation,
                    kafkaSslKeyLocation: this.state.kafkaSslKeyLocation,
                    kafkaSslKeyPassword: this.state.kafkaSslKeyPassword,
                    kafkaSaslMechanism: this.state.kafkaSaslMechanism,
                    kafkaSaslUsername: this.state.kafkaSaslUsername,
                    kafkaSaslPassword: this.state.kafkaSaslPassword,
                }
            });

        switch (data.data.checkKafkaUrlValidity) {
            case "ForbiddenOperation":
                document.getElementById("kafkaBootstrapServersError").innerHTML = "";
                document.getElementById("kafkaBootstrapServers").style.border = "";
                document.getElementById("kafkaTopicError").innerHTML = "";
                document.getElementById("kafkaTopic").style.border = "";
                toast.error("Access Denied", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnKafka').style.border = "2px solid red";
                this.setState({ validateKafkaUrl: "false" });
                break;
            case "InvalidBrokerUrl":
                document.getElementById("kafkaBootstrapServersError").innerHTML = "Error: Broker URL is not valid";
                document.getElementById("kafkaBootstrapServers").style.border = "2px solid red";
                document.getElementById("kafkaTopicError").innerHTML = "";
                document.getElementById("kafkaTopic").style.border = "";
                toast.error("Invalid broker URL", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnKafka').style.border = "2px solid red";
                this.setState({ validateKafkaUrl: "false" });
                break;
            case "InvalidTopicName":
                document.getElementById("kafkaBootstrapServersError").innerHTML = "";
                document.getElementById("kafkaBootstrapServers").style.border = "";
                document.getElementById("kafkaTopicError").innerHTML = "Error: Topic name is not valid";
                document.getElementById("kafkaTopic").style.border = "2px solid red";
                toast.error("Invalid topic name", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnKafka').style.border = "2px solid red";
                this.setState({ validateKafkaUrl: "false" });
                break;
            case "MissingRights":
                document.getElementById("kafkaBootstrapServersError").innerHTML = "";
                document.getElementById("kafkaBootstrapServers").style.border = "";
                document.getElementById("kafkaTopicError").innerHTML = "";
                document.getElementById("kafkaTopic").style.border = "";
                toast.error("Missing Rights", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnKafka').style.border = "2px solid red";
                this.setState({ validateKafkaUrl: "false" });
                break;
            case "UnknownError":
                document.getElementById("kafkaBootstrapServersError").innerHTML = "";
                document.getElementById("kafkaBootstrapServers").style.border = "";
                document.getElementById("kafkaTopicError").innerHTML = "";
                document.getElementById("kafkaTopic").style.border = "";
                toast.error("Unknown Error", { autoClose: 5000, position: "bottom-left" });
                document.querySelector('#checkBtnKafka').style.border = "2px solid red";
                this.setState({ validateKafkaUrl: "false" });
                break;
            case "Valid":
                document.getElementById("kafkaBootstrapServersError").innerHTML = "";
                document.getElementById("kafkaBootstrapServers").style.border = "2px solid green";
                document.getElementById("kafkaTopicError").innerHTML = "";
                document.getElementById("kafkaTopic").style.border = "2px solid green";
                toast.success("Kafka connection is correct", { autoClose: 5000, position: "bottom-left" })
                document.querySelector('#checkBtnKafka').style.border = "2px solid green";
                this.setState({ validateKafkaUrl: "true" });
                break;
        }

        this.handleChange();
    }

    deleteTenant = async (apol) => {
        if (this.state.deletePassword != "3660") {
            this.setState({ deleteTenantText: "Deleting Tenant: wrong Password" });
        } else {
            this.setState({ deleteTenantText: "Deleting Tenant started ..." });

            var data = await apol
                .mutate({
                    mutation: deleteTenant,
                    variables: {
                        auth: this.props.authorization,
                        tenantId: this.props.data.tenantId
                    }
                });
            this.setState({ deleteTenant: false, deleteTenantText: "" });
        }
    }

    checkTenantMetadataForDeletion = async (apol) => {
        var data = await apol
            .mutate({
                mutation: checkTenantForDeletion,
                variables: {
                    auth: this.props.authorization,
                    tenantId: this.props.data.tenantId
                }
            });

        if (data.data.checkTenantForDeletion === true) {
            this.setState({ checkTenantForDelete: true, checkTenantForDeleteError: "" });
        } else {
            this.setState({ checkTenantForDelete: false, checkTenantForDeleteError: "Tenant cannot be deleted." });
        }


    }

    deleteTenantMetadata = async (apol) => {
        if (this.state.deletePassword != "3660") {
            this.setState({ deleteTenantMetadataText: "Deleting Tenant Metadata: wrong Password" });
        } else {
            this.setState({ deleteTenantMetadataText: "Deleting Tenant Metadata started ..." });

            var data = await apol
                .mutate({
                    mutation: deleteTenantMetadataQuery,
                    variables: {
                        auth: this.props.authorization,
                        tenantId: this.props.data.tenantId,
                        date: this.state.deleteTenantMetadataDate
                    }
                });
            if (data.data.deleteTenantRecordings === true) {

                this.setState({
                    deleteTenantMetadataText: "Tenant Metadata Deletion Successful",
                    deleteTenantMetadataStatus: "success"
                });
            } else {
                this.setState({
                    deleteTenantMetadataText: "Tenant Metadata Deletion Unsuccessful",
                    deleteTenantMetadataStatus: "error"
                });

            }


        }
    }

    insertMessage = async (apol) => {
        if (this.state.deletePassword != "") {
            this.setState({ insertMessageText: "Please input message" });
        } else {

            var data = await apol
                .mutate({
                    mutation: insertMessage,
                    variables: {
                        auth: this.props.authorization,
                        message: this.state.insertMessageContent
                    }
                });
            this.setState({ insertMessage: false, insertMessageText: "" });
        }
    }

    handleCreateAsymmetricKey = async (apolo) => {
        if (this.state.keySetting === "") {
            document.getElementById("keySettingError").innerHTML = "Key Setting is required";
            document.getElementById("keySetting").style.border = "2px solid red";
        } else {
            var data = await apolo
                .mutate({
                    mutation: createAsymmetricKey,
                    variables: {
                        tenantid: this.state.tenantId,
                        vaultUrl: this.state.keyManagementType === "CustomKey" ? this.state.customEncryptionKeyVaultUrl : "",
                        keyName: this.state.keyManagementType === "CustomKey" ? this.state.customEncryptionKeySecretName : "",
                        keySize: Number(this.state.keySetting),
                        hsm: this.state.hsm
                    }
                });
            if (data.data.createAsymmetricKey) {
                toast.success("Asymmetric Key Creation Successful", { autoClose: 5000, position: "bottom-left" });

            } else {
                toast.error("Asymmetric Key Creation Unsuccessful", { autoClose: 5000, position: "bottom-left" });
            }
        }

    }

    notifyTenantChange = async (apol) => {
        this.setState({ isSaving: true });
        try {
        // Add or change User

        // Repair legacy settings with 0001 year
        if (new Date(this.state.onboardingDate).toDateString() === new Date("0001-01-01T00:00:00.0000000").toDateString())
            this.setState({ onboardingDate: new Date("1901-01-01T00:00:00") });
        if (new Date(this.state.trainingDate).toDateString() === new Date("0001-01-01T00:00:00.0000000").toDateString())
            this.setState({ trainingDate: new Date("1901-01-01T00:00:00") });
        if (new Date(this.state.billingDate).toDateString() === new Date("0001-01-01T00:00:00.0000000").toDateString())
            this.setState({ billingDate: new Date("1901-01-01T00:00:00") });
        let tmpExpireDays = this.state.expireDays;
        if (!this.state.willExpire) {
            tmpExpireDays = 0;
        }

        //clear any extra commas or white spaces
        const cleanedMailAlarming = this.state.mailAlarming
            ? this.state.mailAlarming
                .split(",")
                .map(e => e.trim())
                .filter(e => e.length > 0)
                .join(",")
            : "";
        const botsCleaned = this.state.bots.map(({ __typename, ...bot }) => bot);
        var tenant = {
            name: this.state.name,
            tenantId: this.state.tenantId,
            adminId: this.state.adminId,
            licenseComp: {
                type: {
                    id: "1",
                    number: "1",
                    text: "1",
                    name: "ComplianceRec"
                },
                bought: parseInt(this.state.license1),
                used: parseInt(this.state.license1used),
                id: this.state.license1id
            },
            licenseCompAna: {
                type: {
                    id: "2",
                    number: "2",
                    text: "2",
                    name: "ComplianceRec&Ana"
                },
                bought: parseInt(this.state.license2),
                used: parseInt(this.state.license2used),
                id: this.state.license2id
            },
            licenseSmart: {
                type: {
                    id: "3",
                    number: "3",
                    text: "3",
                    name: "SmartRec"
                },
                bought: parseInt(this.state.license3),
                used: parseInt(this.state.license3used),
                id: this.state.license3id
            },
            licenseSmartAna: {
                type: {
                    id: "4",
                    number: "4",
                    text: "4",
                    name: "SmartRecAna"
                },
                bought: parseInt(this.state.license4),
                used: parseInt(this.state.license4used),
                id: this.state.license4id
            },
            licenseAna: {
                type: {
                    id: "5",
                    number: "5",
                    text: "5",
                    name: "Ana"
                },
                bought: parseInt(this.state.license5),
                used: parseInt(this.state.license5used),
                id: this.state.license5id
            },
            licenseCompVoice: {
                type: {
                    id: "6",
                    number: "6",
                    text: "6",
                    name: "CompVoice"
                },
                bought: parseInt(this.state.license6),
                used: parseInt(this.state.license6used),
                id: this.state.license6id
            },
            licenseCompVoiceAna: {
                type: {
                    id: "7",
                    number: "7",
                    text: "7",
                    name: "CompVoiceAna"
                },
                bought: parseInt(this.state.license7),
                used: parseInt(this.state.license7used),
                id: this.state.license7id
            },
            licenseSmartVoice: {
                type: {
                    id: "8",
                    number: "8",
                    text: "8",
                    name: "SmartVoice"
                },
                bought: parseInt(this.state.license8),
                used: parseInt(this.state.license8used),
                id: this.state.license8id
            },
            licenseSmartVoiceAna: {
                type: {
                    id: "9",
                    number: "9",
                    text: "9",
                    name: "SmartVoiceAna"
                },
                bought: parseInt(this.state.license9),
                used: parseInt(this.state.license9used),
                id: this.state.license9id
            },
            licenseRecordingInsinghtsAI: {
                type: {
                    id: "10",
                    number: "10",
                    text: "10",
                    name: "LicenseRecordingInsinghtsAI"
                },
                bought: parseInt(this.state.license10),
                used: parseInt(this.state.license10used),
                id: this.state.license10id
            },
            licenseSmartBase: {
                type: {
                    id: "11",
                    number: "11",
                    text: "11",
                    name: "licenseSmartBase"
                },
                bought: parseInt(this.state.license11),
                used: parseInt(this.state.license11used),
                id: this.state.license11id
            },
            licenseComplianceBase: {
                type: {
                    id: "12",
                    number: "12",
                    text: "12",
                    name: "licenseComplianceBase"
                },
                bought: parseInt(this.state.license12),
                used: parseInt(this.state.license12used),
                id: this.state.license12id
            },
            licenseEntryVoiceRecording: {
                type: {
                    id: "13",
                    number: "13",
                    text: "13",
                    name: "licenseEntryVoiceRecording"
                },
                bought: parseInt(this.state.license13),
                used: parseInt(this.state.license13used),
                id: this.state.license13id
            },
            storageId: this.state.storage,
            packageStorage: parseInt(this.state.packageStorage),
            packageAnalyticsVideo: parseInt(this.state.packageAnalyticsVideo),
            packageAnalyticsSpeech: parseInt(this.state.packageAnalyticsSpeech),
            packageAnalyticsTranscript: parseInt(this.state.packageAnalyticsTranscript),
            packageAnalyticsBatchTranscript: parseInt(this.state.packageAnalyticsBatchTranscript),
            packageAnalyticsTranslate: parseInt(this.state.packageAnalyticsTranslate),
            packageAnalyticsAI: parseInt(this.state.packageAnalyticsAI),
            analyticsSpeechCapacity: this.state.analyticsSpeechCapacity,
            analyticsTranscriptCapacity: this.state.analyticsTranscriptCapacity,
            analyticsBatchTranscriptCapacity: this.state.analyticsBatchTranscriptCapacity,
            analyticsVideoCapacity: this.state.analyticsVideoCapacity,
            analyticsTranslateCapacity: this.state.analyticsTranslateCapacity,
            analyticsAICapacity: this.state.analyticsAICapacity,
            packageExport: parseInt(this.state.packageExport),
            packageArchive: parseInt(this.state.packageArchive),
            addOnAnalytics: parseInt(this.state.addOnAnalytics),
            addOnAIEntry: parseInt(this.state.addOnAIEntry),
            addOnFullChat: parseInt(this.state.addOnFullChat),
            addOnZoom: parseInt(this.state.addOnZoom),
            addOnGenesys: parseInt(this.state.addOnGenesys),
            addOnRingcentral: parseInt(this.state.addOnRingcentral),
            addOnCloud9: parseInt(this.state.addOnCloud9),
            addOnDynamics: parseInt(this.state.addOnDynamics),
            addOnWebex: parseInt(this.state.addOnWebex),
            addOnCompliance: parseInt(this.state.addOnCompliance),
            addOnQualityManagement: parseInt(this.state.addOnQualityManagement),
            addOnRealTimeTranscript: parseInt(this.state.addOnRealTimeTranscript),
            addOnLeapXpert: parseInt(this.state.addOnLeapXpert),
            addOnMsftTeamsVoice: parseInt(this.state.addOnMsftTeamsVoice),
            addOnMsftTeamsUC: parseInt(this.state.addOnMsftTeamsUC),
            addOnEmail: parseInt(this.state.addOnEmail),
            addOnN1Mapping: parseInt(this.state.addOnN1Mapping),
            contractNumber: this.state.contractNumber,
            domainRestrictionsList: this.state.domainRestrictionsList,
            mailAlarming: cleanedMailAlarming,
            commercialContactMail: this.state.commercialContactMail,
            customStorage: this.state.customStorage,
            exportType: this.state.exportType,
            exportStorage: this.state.exportStorage,
            type: this.state.type,
            id: this.state.id,
            country: this.state.country,
            partner: this.state.partner,
            onboardingDate: this.state.onboardingDate === '' ? '1901-01-01' : this.state.onboardingDate.toUTCString(),
            billingDate: this.state.billingDate === '' ? '1901-01-01' : this.state.billingDate.toUTCString(),
            trainingDate: this.state.trainingDate === '' ? '1901-01-01' : this.state.trainingDate.toUTCString(),
            supportNotes: this.state.supportNotes,
            systemId: this.state.systemId,
            partnerContract: this.state.partnerContract,
            support: this.state.support,
            keyManagementType: this.state.keyManagementType,
            keyManagement: {
                rotationType: this.state.rotationType,
                intervalDays: parseInt(this.state.intervalDays),
                activationDelay: parseInt(this.state.activationDelay),
                willExpire: this.state.willExpire ? "Yes" : "No",
                expireDays: parseInt(tmpExpireDays),
                keySecurity: this.state.keySecurity,
                customEncryptionKeyVaultUrl: this.state.customEncryptionKeyVaultUrl,
                customEncryptionKeySecretName: this.state.customEncryptionKeySecretName,
                asymmetricKeyEnabled: this.state.asymmetricKeyEnabled,
                asymmetricKeySettings: {
                    keyType: this.state.keyType,
                    keySetting: this.state.keySetting,
                    asymmetricKeyFileName: this.state.asymmetricKeyFileName
                },
            },
            packageImport: this.state.packageImport,
            tenantSuspensionConvDelProcess: this.state.tenantSuspensionConvDelProcess,
            awsAccessKeyId: this.state.awsAccessKeyId,
            awsSecretAccess: this.state.awsSecretAccess,
            awsBucketName: this.state.awsBucketName,
            awsRegion: this.state.awsRegion,
            awsServiceUrl: this.state.awsServiceUrl,
            awsType: this.state.awsType,
            chatModelA: this.state.chatModelA,
            showTicketPage: this.state.showTicketPage,
            interactionLogging: this.state.interactionLogging != null ? this.state.interactionLogging : false,
            loggingStartDate: this.state.interactionLogging === true ? this.state.loggingStartDate : null,
            loggingStopDate: this.state.interactionLogging === true ? this.state.loggingStopDate : null,
            allowedUsers: (this.state.interactionLogging === true && this.state.allowedUsers.length > 0) ? this.state.allowedUsers.map(userIdOrGroupId => ({ userId: userIdOrGroupId })) : null,
            processingRegion: this.state.processingRegion,
            eventHubNamespace: this.state.eventHubNamespace,
            eventHubName: this.state.eventHubName,
            kafkaBootstrapServers: this.state.kafkaBootstrapServers,
            kafkaTopic: this.state.kafkaTopic,
            kafkaSecurityProtocol: this.state.kafkaSecurityProtocol,
            kafkaSslCaLocation: this.state.kafkaSslCaLocation,
            kafkaSslCertificateLocation: this.state.kafkaSslCertificateLocation,
            kafkaSslKeyLocation: this.state.kafkaSslKeyLocation,
            kafkaSslKeyPassword: this.state.kafkaSslKeyPassword,
            kafkaSaslMechanism: this.state.kafkaSaslMechanism,
            kafkaSaslUsername: this.state.kafkaSaslUsername,
            kafkaSaslPassword: this.state.kafkaSaslPassword,
            bots: botsCleaned
        };

        if (this.props.data != null) {
            var data = await apol
                .mutate({
                    mutation: mutationUpdateTenant,
                    refetchQueries: [{
                        query: queryGetTenantList,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        auth: this.props.authorization,
                        tenant: tenant
                    }
                });
            if (data.data.updateTenant == null || data.data.updateTenant.name === "error") {
                toast.error(data.data.updateTenant.text, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            } else {
                const currentAudioStorage = this.state.audioStorageOverride != null ? this.state.audioStorageOverride : this.props.data.audioStorage;
                if (parseInt(this.state.packageArchive) === 0 && currentAudioStorage != null && currentAudioStorage.archiveBlobs === true) {
                    // no archive package assigned anymore: keep the persisted archiveBlobs flag in sync so it can't stay silently active
                    await apol.mutate({
                        mutation: mutationUpdateAudioStorage,
                        variables: {
                            auth: this.props.authorization,
                            audioStorage: {
                                id: currentAudioStorage.id,
                                tenantId: currentAudioStorage.tenantId,
                                convertToMP3: currentAudioStorage.convertToMP3,
                                convertBlobOlderThanDays: currentAudioStorage.convertBlobOlderThanDays,
                                archiveBlobs: false,
                                archiveBlobOlderThanDays: currentAudioStorage.archiveBlobOlderThanDays,
                                archiveDestinationAudioFormat: currentAudioStorage.archiveDestinationAudioFormat
                            }
                        }
                    });
                }
                toast.success(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "tenantChanged")}</>)}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                this.props.cl();
            }

        } else {
            data = await apol
                .mutate({
                    mutation: mutationCreateTenant,
                    refetchQueries: [{
                        query: queryGetTenantList,
                        variables: { auth: this.props.authorization },
                    }],
                    variables: {
                        auth: this.props.authorization,
                        tenant: tenant,
                        createSubUnit: this.state.createSubUnit
                    }
                });
            if (data.data.createTenant == null || data.data.createTenant.name === "error") {
                console.log(data)
                if (data.data.createTenant.name === "error") {
                    if (data.data.createTenant.text === "Tenant with the same TenantId already exists.") {

                        this.setState({ createSubUnit: true }, () => {
                            console.log('createSubUnit after setState:', this.state.createSubUnit);
                        }); return;

                    } else if (data.data.createTenant.text === "Admin user already exists") {
                        this.setState(
                            prev => ({
                                error: { ...prev.error, adminId: "adminIdAlreadyExists" },
                                createSubUnit: false
                            })
                        );
                        return;
                    }
                } else {
                    this.setState({ createSubUnit: false });
                    toast.error(data.data.createTenant.text, {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    return;
                }


                toast.error(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "unknownError")}</>)}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });

            } else {
                toast.success(<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "tenantAdded")}</>)}</MyContext.Consumer>, {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                this.props.cl();
            }


        }
        } finally {
            this.setState({ isSaving: false });
        }
    };
    componentDidUpdate = () => {
        console.log(this.state);
    }

    changeUserPicker = (users) => {
        this.setState({ allowedUsers: users.map(u => u.userId) })
    }

    openExportSettings = () => {
        return <ExportConfig cl={this._onDismissExportPanel} />
    }

    _onDismissExportPanel() {
        this.setState({ showExportPanel: false });
    }

    _onOpenExportPanel() {
        this.setState({ showExportPanel: true });
    }

    openImportSettings = () => {
        return <ImportConfig cl={this._onDismissImportPanel} />

    }
    _onDismissImportPanel() {
        this.setState({ showImportPanel: false });
    }
    _onOpenImportPanel() {
        this.setState({ showImportPanel: true });
    }
    openAudioStorageSettings = (audioStorage, storage) => {
        return <AudioStorageConfig tenantId={this.state.tenantId} apol={this.props.apol} authorization={this.props.authorization} data={audioStorage} cl={this._onDismissAudioStoragePanel} storageType={storage} packageArchive={this.state.packageArchive} />

    }
    _onDismissAudioStoragePanel(audioStorage) {
        this.setState(prevState => ({
            showAudioStoragePanel: false,
            audioStorageOverride: audioStorage !== undefined ? audioStorage : prevState.audioStorageOverride
        }));
    }
    _onOpenAudioStoragePanel() {
        this.setState({ showAudioStoragePanel: true });
    }
    openBotOnboardingSettings = () => {
        return <BotOnboardingConfig tenantId={this.state.tenantId} apol={this.props.apol} cl={this._onDismissBotOnboardingPanel} />
    }
    _onDismissBotOnboardingPanel() {
        this.setState({ showBotOnboardingPanel: false });
    }
    _onOpenBotOnboardingPanel() {
        this.setState({ showBotOnboardingPanel: true });
    }
    _closeModal = () => {
        this.setState({ showModal: false });
    }
    _openModal = () => {
        this.setState({ showModal: true });
    }
    checkKeyExpirationValidity = async (apol) => {
        this.setState({ TTLLoading: true });
        var data = await apol
            .mutate({
                mutation: checkMaxRetentionTimeSettings,
                variables: {
                    tenantId: this.state.tenantId
                }
            });

        this.setState({
            maxTtlFound: data.data.checkMaxRetentionTimeSettings
        });

        if (this.state.expireDays >= (data.data.checkMaxRetentionTimeSettings + this.state.intervalDays)) {
            this.setState({ keyExpirationConfirmed: true });
            document.getElementById("expirationDaysField").style.border = "1px solid green";
            document.querySelector('#keyExpirationBtn').style.border = "1px solid green";
        }
        else {
            document.getElementById("expirationDaysField").style.border = "1px solid orange";
            document.querySelector('#keyExpirationBtn').style.border = "1px solid orange";
            this.setState({ keyExpirationButtonMessage: true })

        }
        this.setState({ TTLLoading: false });

    }
}
function accessOption(rule) {
    let out = [];
    let tmp = [];
    for (let i = 0; i < rule.length; i++) {
        if ((rule[i].group === "access"))//filter the Rule Type
        {
            tmp.push(rule[i]);
        }
    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Access Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name });
            }
            break;
    }
    return out;
}
function analyticsOption(rule) {
    let out = [];
    let tmp = [];
    for (let i = 0; i < rule.length; i++) {
        if ((rule[i].group === "analytics"))//filter the Rule Type
        {
            tmp.push(rule[i]);
        }
    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Analytic Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name, title: tmp[i].usage });
            }
            break;
    }
    return out;
} function recordingOption(rule) {
    let out = [];
    let tmp = [];
    if (rule != null) {
        for (let i = 0; i < rule.length; i++) {
            if ((rule[i].group === "recording"))//filter the Rule Type
            {
                tmp.push(rule[i]);
            }
        }
    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Recording Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name, title: tmp[i].usage });
            }
            break;
    }
    return out;
} function replayOption(rule) {
    let out = [];
    let tmp = [];
    for (let i = 0; i < rule.length; i++) {
        if ((rule[i].group === "replay"))//filter the Rule Type
        {
            tmp.push(rule[i]);
        }

    }
    switch (tmp) {
        case 0: out.push({ key: "no Rule", text: "no Rule", disabled: true }); break;
        case 1: out.push({ key: tmp[0].id, text: tmp[0].name, disabled: true }); break;
        default:
            out.push({ key: 'Header', text: 'Replay Rules', itemType: DropdownMenuItemType.Header });
            for (let i = 0; i < tmp.length; i++) {
                out.push({ key: tmp[i].id, text: tmp[i].name, title: tmp[i].usage });
            }
            break;
    }
    return out;
}

function isValidUUID(uuid) {
    return /^[0-9A-Fa-f]{8}(-[0-9A-Fa-f]{4}){3}-[0-9A-Fa-f]{12}$/.test(uuid);
}